//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.0.0 (NJsonSchema v11.5.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const AmpV1_BASE_URL = new InjectionToken<string>('AmpV1_BASE_URL');

export interface IAmpV1Service {
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ApplicationDto  entities
     * @return Success
     */
    getAllApplicationEntities(): Observable<ApplicationDto[]>;
    /**
     * Add a new application
     * @param body (optional) 
     * @return Success
     */
    postApplication(body: ApplicationDto | undefined): Observable<ContentVersionDto>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putApplication(body: ApplicationDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ApplicationDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getApplicationById(id: number): Observable<ApplicationDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteApplication(id: number): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ApplicationDto based on the unique identifier of a related WE.AMP.Models.DataTransferObjects.ContentVersionDto, includes the
     * @param contentVersionId Unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getApplicationByContentVersionId(contentVersionId: number): Observable<ApplicationDto>;
    /**
     * Get application icons for brand or logo
     * @param isBrand flag is set to get the icons for brand
     * @return Success
     */
    getApplicationIcons(isBrand: boolean): Observable<ImageIconSelectBoxDto[]>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto  entities
     * @return Success
     */
    getAllAssessmentEntities(): Observable<AssessmentEntityDto[]>;
    /**
     * Add WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto
     * @param body (optional) 
     * @return Success
     */
    postAssessment(body: AssessmentEntityDto | undefined): Observable<void>;
    /**
     * Update an existing entity WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAssessment(body: AssessmentEntityDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getAssessmentById(id: number): Observable<AssessmentEntityDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAssessment(id: number): Observable<void>;
    /**
     * Get a list of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityManualSectionDto based on an unique identifier
     * @param key Unique identifier
     * @return Success
     */
    getAssessmentManualSections(key: string): Observable<AssessmentEntityManualSectionDto[]>;
    /**
     * Retrieves all AMP keys that have associated help texts for the specified assessment entity type.
     * @param assessmentEntityTypeId (optional) The identifier of the assessment entity type to filter AMP keys by. If null, retrieves AMP keys for all entity
                types.
     * @return Success
     */
    getAllAmpKeysThatHaveHelpTexts(assessmentEntityTypeId: number | undefined): Observable<string[]>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionByAssessmentSubjectDto  entities
     * @return Success
     */
    getAllAssessmentEntityByContentVersionByAssessmentSubjectEntities(): Observable<AssessmentEntityByContentVersionByAssessmentSubjectDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAssessmentEntityByContentVersionByAssessmentSubject(body: AssessmentEntityByContentVersionByAssessmentSubjectDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAssessmentEntityByContentVersionByAssessmentSubject(body: AssessmentEntityByContentVersionByAssessmentSubjectDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAssessmentEntityByContentVersionByAssessmentSubject(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto  entities
     * @return Success
     */
    getAllAssessmentEntityTypeEntities(): Observable<AssessmentEntityTypeDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAssessmentEntityType(body: AssessmentEntityTypeDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAssessmentEntityType(body: AssessmentEntityTypeDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAssessmentEntityType(id: number): Observable<void>;
    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.BuildingAssessmentModelMatrixDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier
     * @return Success
     */
    getBuildingConfigurationByContentVersionId(contentVersionId: number): Observable<BuildingAssessmentModelMatrixDto[]>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto  entities
     * @return Success
     */
    getAllCalculationCoreEntities(): Observable<CalculationCoreDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCore(body: CalculationCoreDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCore(body: CalculationCoreDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreById(id: number): Observable<CalculationCoreDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCore(id: number): Observable<void>;
    /**
     * Gets all DataMemeber names that can be linked to a WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto
     * @param calculationCoreVersionId Unique identifier for the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto
     * @return Success
     */
    getRequestDataMemberNames(calculationCoreVersionId: number): Observable<string[]>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto  entities
     * @return Success
     */
    getAllCalculationCoreExpressionEntities(): Observable<CalculationCoreExpressionDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreExpression(body: CalculationCoreExpressionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreExpression(body: CalculationCoreExpressionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreExpressionById(id: number): Observable<CalculationCoreExpressionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreExpression(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto  entities
     * @return Success
     */
    getAllCalculationCoreResultExpressionEntities(): Observable<CalculationCoreResultExpressionDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreResultExpression(body: CalculationCoreResultExpressionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreResultExpression(body: CalculationCoreResultExpressionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreResultExpressionById(id: number): Observable<CalculationCoreResultExpressionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreResultExpression(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto  entities
     * @return Success
     */
    getAllCalculationCoreVersionEntities(): Observable<CalculationCoreVersionDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreVersion(body: CalculationCoreVersionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreVersion(body: CalculationCoreVersionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreVersionById(id: number): Observable<CalculationCoreVersionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreVersion(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ContentVersionDto  entities
     * @return Success
     */
    getAllContentVersionEntities(): Observable<ContentVersionDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postContentVersion(body: ContentVersionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putContentVersion(body: ContentVersionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ContentVersionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getContentVersionById(id: number): Observable<ContentVersionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteContentVersion(id: number): Observable<void>;
    /**
     * Get a collection of WE.AMP.Models.DataTransferObjects.ContentVersionDto for an WE.AMP.Models.DataTransferObjects.ApplicationDto
     * @param id Unique Identifier
     * @return Success
     */
    getContentVersionByApplication(id: number): Observable<ContentVersionDto>;
    /**
     * Copy of WE.AMP.Models.DataTransferObjects.ContentVersionDto for an WE.AMP.Models.DataTransferObjects.ApplicationDto
     * @param id Unique Identifier
     * @return Success
     */
    copyContentVersion(id: number): Observable<ContentVersionDto>;
    /**
     * Export of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    exportContentVersion(contentVersionId: number): Observable<ContentVersionExportDto>;
    /**
     * Checks if the session is valid  for WE.AMP.Models.DataTransferObjects.ContentVersionDto  and WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto for that user WE.AMP.Models.DataTransferObjects.UserDto and perform actions on it
     * @return Created
     */
    getEditSessionBycontentVersionIdByeditSessionTypeId(contentVersionId: number, editSessionTypeId: number): Observable<EditSessionDto>;
    /**
     * Deletes an edit session for WE.AMP.Models.DataTransferObjects.ContentVersionDto and WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto for the logged in user WE.AMP.Models.DataTransferObjects.UserDto
     * @return No Content
     */
    deleteEditSessionBycontentVersionIdByeditSessionTypeId(contentVersionId: number, editSessionTypeId: number): Observable<EditSessionDto>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postEditSession(body: EditSessionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putEditSession(body: EditSessionDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteEditSession(id: number): Observable<void>;
    /**
     * Gets unmapped single elements from WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getUnmappedSingleElements(contentVersionId: number): Observable<SelectBoxDto[]>;
    /**
     * Get all WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto with related WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto for given WE.AMP.Models.DataTransferObjects.ContentVersionDto<param name="contentVersionId">unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto</param>
     * @return Success
     */
    getAllElement(contentVersionId: number): Observable<ElementDto[]>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto based on an unique identifier for given WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param id Unique identifier
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getElementById(id: number, contentVersionId: number): Observable<ElementDto>;
    /**
     * Add new WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto<br>If WE.AMP.Models.DataTransferObjects.ProjectModel.ProjectModelDto.AddToTree is set to true then it will add WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto to WE.AMP.Models.DataTransferObjects.ContentVersionDto including child element and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDtoif specified
     * @param body (optional) Data Transfer Object for the adding WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto
     * @return Created
     */
    postElementSave(body: ProjectModelDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param contentVersionId unique identifier or WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param body (optional) updated object for WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto
     * @return Success
     */
    putElementUpdate(contentVersionId: number, body: ElementDto | undefined): Observable<void>;
    /**
     * Get's a list of child elements
     * @param elementByContentVersionId Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto
     * @return Success
     */
    getElementGetChildren(elementByContentVersionId: number): Observable<SelectBoxDto[]>;
    /**
     * Get list of root WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto in WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getElementGetRootElements(contentVersionId: number): Observable<SelectBoxDto[]>;
    /**
     * Get element icons based on element type
     * @return Success
     */
    getElementGetIcons(elementTypeId: number): Observable<ImageIconSelectBoxDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postElement(body: ElementDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putElement(body: ElementDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteElement(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto  entities
     * @return Success
     */
    getAllElementOverrideEntities(): Observable<ElementOverrideDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postElementOverride(body: ElementOverrideDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putElementOverride(body: ElementOverrideDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getElementOverrideById(id: number): Observable<ElementOverrideDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteElementOverride(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForFlatListDto entities with flags set whether the entities are or aren't used in the WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    entityForFlatListAssessmentModel(contentVersionId: number): Observable<AssessmentOrProjectModelEntityForFlatListDto[]>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForFlatListDto entities with flags set whether the entities are or aren't used in the WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    entityForFlatListProjectModel(contentVersionId: number): Observable<AssessmentOrProjectModelEntityForFlatListDto[]>;
    /**
     * Gets all possible values of AssessmentSubjectType for use in frontend selection
     * @return Success
     */
    getAssessmentSubjectTypes(): Observable<SmartEnumDto[]>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto  entities
     * @return Success
     */
    getAllExpressionEntities(): Observable<ParameterToAssessmentExpressionDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postExpression(body: ParameterToAssessmentExpressionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putExpression(body: ParameterToAssessmentExpressionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getExpressionById(id: number): Observable<ParameterToAssessmentExpressionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteExpression(id: number): Observable<void>;
    /**
     * Get a collection of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto based on an unique identifier for a WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique identifier of a WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getExpressionByContentVersionId(contentVersionId: number): Observable<ParameterToAssessmentExpressionDto[]>;
    /**
     * Removes the relation to (mapping of) WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto from WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto
     * @param expressionId Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto
     * @return Success
     */
    deleteExpressionRemoveRelationToAssessmentEntity(expressionId: number): Observable<void>;
    /**
     * Check if the given expression is valid or invalid
     * @param body (optional) 
     * @return Success
     */
    validateExpressionExpression(body: string | undefined): Observable<ParameterToAssessmentExpressionDto[]>;
    /**
     * Get a tree ofWE.AMP.Models.DataTransferObjects.FormlyModel.FormlyProjectModelTreeDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier WE.AMP.Models.Entities.ContentVersion
     * @return Success
     */
    formlyModel(contentVersionId: number): Observable<FormlyProjectModelTreeDto>;
    /**
     * Save user inputs from the Assessment Model Matrix
     * @param contentVersionId (optional) user input for model matrix
     * @return Success
     */
    getMatrix(contentVersionId: number | undefined): Observable<AssessmentModelMatrixDto[]>;
    /**
     * Save user inputs from the Assessment Model Matrix
     * @param body (optional) user input for model matrix
     * @return Created
     */
    saveMatrix(body: AssessmentEntityByContentVersionDto[] | undefined): Observable<void>;
    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier
     * @return Success
     */
    modelTreeAssessmentModel(contentVersionId: number): Observable<ModelTreeDto>;
    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and its WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier
     * @return Success
     */
    modelTreeProjectModel(contentVersionId: number): Observable<ModelTreeDto>;
    /**
     * Save changes to the WE.AMP.Models.DataTransferObjects.ModelTreeDto
     * @param body (optional) Data Transfer Object for the tree
     * @return Created
     */
    saveModelTreeTree(body: ModelTreeDto | undefined): Observable<void>;
    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto with WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    modelTreeGetAssessmentModelTreeWithExpressions(contentVersionId: number): Observable<ExpressionModelTreeDto>;
    /**
     * Get a tree ofWE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto for expression
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    modelTreeGetProjectModelTreeForExpression(contentVersionId: number): Observable<ExpressionModelTreeDto>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.OrganizationDto  entities
     * @return Success
     */
    getAllOrganizationEntities(): Observable<OrganizationDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postOrganization(body: OrganizationDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putOrganization(body: OrganizationDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.OrganizationDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getOrganizationById(id: number): Observable<OrganizationDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteOrganization(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto  entities for given WE.AMP.Models.DataTransferObjects.ContentVersionDto<param name="contentVersionId">unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto</param>
     * @return Success
     */
    getAllParameterEntities(contentVersionId: number): Observable<ParameterDto[]>;
    /**
     * Gets list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto from WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getParameters(contentVersionId: number): Observable<SelectBoxDto[]>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto based on an unique identifier for given WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param id Unique identifier
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getParameterById(id: number, contentVersionId: number): Observable<ParameterDto>;
    /**
     * Update an existing entity
     * @param contentVersionId (optional) unique identifier or WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param body (optional) updated object for WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto
     * @return Success
     */
    putParameterUpdate(contentVersionId: number | undefined, body: ParameterDto | undefined): Observable<void>;
    /**
     * Add a new parameter
     * @param body (optional) 
     * @return Created
     */
    postParameter(body: ParameterDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameter(body: ParameterDto | undefined): Observable<void>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameter(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto  entities
     * @return Success
     */
    getAllParameterByCalculationCoreExpressionEntities(): Observable<ParameterByCalculationCoreExpressionDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterByCalculationCoreExpression(body: ParameterByCalculationCoreExpressionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterByCalculationCoreExpression(body: ParameterByCalculationCoreExpressionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getParameterByCalculationCoreExpressionById(id: number): Observable<ParameterByCalculationCoreExpressionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterByCalculationCoreExpression(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto  entities
     * @return Success
     */
    getAllParameterOptionEntities(): Observable<ParameterOptionDto[]>;
    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterOption(body: ParameterOptionDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterOption(body: ParameterOptionDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getParameterOptionById(id: number): Observable<ParameterOptionDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterOption(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.FormlyModel.PatternDto entities
     * @return Success
     */
    getAllPatternEntities(): Observable<PatternDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postPattern(body: PatternDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putPattern(body: PatternDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.FormlyModel.PatternDto   based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getPatternById(id: number): Observable<PatternDto[]>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deletePattern(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto entities
     * @return Success
     */
    getAllTemplateOptionsEntities(): Observable<TemplateOptionsDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postTemplateOptions(body: TemplateOptionsDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putTemplateOptions(body: TemplateOptionsDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto   based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getTemplateOptionsById(id: number): Observable<TemplateOptionsDto[]>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteTemplateOptions(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.UnitDto  entities
     * @return Success
     */
    getAllUnitEntities(): Observable<UnitDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postUnit(body: UnitDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putUnit(body: UnitDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.UnitDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getUnitById(id: number): Observable<UnitDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteUnit(id: number): Observable<void>;
    /**
     * Gets all WE.AMP.Models.DataTransferObjects.UserDto  entities
     * @return Success
     */
    getAllUserEntities(): Observable<UserDto[]>;
    /**
     * @param body (optional) 
     * @return Created
     */
    postUser(body: UserDto | undefined): Observable<void>;
    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putUser(body: UserDto | undefined): Observable<void>;
    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.UserDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getUserById(id: number): Observable<UserDto>;
    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteUser(id: number): Observable<void>;
}

@Injectable()
export class AmpV1Service implements IAmpV1Service {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(AmpV1_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ApplicationDto  entities
     * @return Success
     */
    getAllApplicationEntities(): Observable<ApplicationDto[]> {
        let url_ = this.baseUrl + "/api/v1/Application";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllApplicationEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllApplicationEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto[]>;
        }));
    }

    protected processGetAllApplicationEntities(response: HttpResponseBase): Observable<ApplicationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new application
     * @param body (optional) 
     * @return Success
     */
    postApplication(body: ApplicationDto | undefined): Observable<ContentVersionDto> {
        let url_ = this.baseUrl + "/api/v1/Application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
                "Accept": "text/plain; x-api-version=1.0"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentVersionDto>;
        }));
    }

    protected processPostApplication(response: HttpResponseBase): Observable<ContentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Created", status, _responseText, _headers);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putApplication(body: ApplicationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ApplicationDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getApplicationById(id: number): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/v1/Application/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processGetApplicationById(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteApplication(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Application/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteApplication(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ApplicationDto based on the unique identifier of a related WE.AMP.Models.DataTransferObjects.ContentVersionDto, includes the
     * @param contentVersionId Unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getApplicationByContentVersionId(contentVersionId: number): Observable<ApplicationDto> {
        let url_ = this.baseUrl + "/api/v1/Application/GetByContentVersion/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationByContentVersionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationByContentVersionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ApplicationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ApplicationDto>;
        }));
    }

    protected processGetApplicationByContentVersionId(response: HttpResponseBase): Observable<ApplicationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get application icons for brand or logo
     * @param isBrand flag is set to get the icons for brand
     * @return Success
     */
    getApplicationIcons(isBrand: boolean): Observable<ImageIconSelectBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Application/GetIcons/{isBrand}";
        if (isBrand === undefined || isBrand === null)
            throw new globalThis.Error("The parameter 'isBrand' must be defined.");
        url_ = url_.replace("{isBrand}", encodeURIComponent("" + isBrand));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain; x-api-version=1.0"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationIcons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationIcons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageIconSelectBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageIconSelectBoxDto[]>;
        }));
    }

    protected processGetApplicationIcons(response: HttpResponseBase): Observable<ImageIconSelectBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageIconSelectBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto  entities
     * @return Success
     */
    getAllAssessmentEntities(): Observable<AssessmentEntityDto[]> {
        let url_ = this.baseUrl + "/api/v1/Assessment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssessmentEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssessmentEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentEntityDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentEntityDto[]>;
        }));
    }

    protected processGetAllAssessmentEntities(response: HttpResponseBase): Observable<AssessmentEntityDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentEntityDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto
     * @param body (optional) 
     * @return Success
     */
    postAssessment(body: AssessmentEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Assessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAssessment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAssessment(body: AssessmentEntityDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Assessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAssessment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getAssessmentById(id: number): Observable<AssessmentEntityDto> {
        let url_ = this.baseUrl + "/api/v1/Assessment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssessmentById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssessmentById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentEntityDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentEntityDto>;
        }));
    }

    protected processGetAssessmentById(response: HttpResponseBase): Observable<AssessmentEntityDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssessmentEntityDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAssessment(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Assessment/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssessment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a list of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityManualSectionDto based on an unique identifier
     * @param key Unique identifier
     * @return Success
     */
    getAssessmentManualSections(key: string): Observable<AssessmentEntityManualSectionDto[]> {
        let url_ = this.baseUrl + "/api/v1/Assessment/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssessmentManualSections(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssessmentManualSections(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentEntityManualSectionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentEntityManualSectionDto[]>;
        }));
    }

    protected processGetAssessmentManualSections(response: HttpResponseBase): Observable<AssessmentEntityManualSectionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentEntityManualSectionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieves all AMP keys that have associated help texts for the specified assessment entity type.
     * @param assessmentEntityTypeId (optional) The identifier of the assessment entity type to filter AMP keys by. If null, retrieves AMP keys for all entity
                types.
     * @return Success
     */
    getAllAmpKeysThatHaveHelpTexts(assessmentEntityTypeId: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/Assessment/GetAllAmpKeysThatHaveHelpTexts?";
        if (assessmentEntityTypeId === null)
            throw new globalThis.Error("The parameter 'assessmentEntityTypeId' cannot be null.");
        else if (assessmentEntityTypeId !== undefined)
            url_ += "assessmentEntityTypeId=" + encodeURIComponent("" + assessmentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAmpKeysThatHaveHelpTexts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAmpKeysThatHaveHelpTexts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetAllAmpKeysThatHaveHelpTexts(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionByAssessmentSubjectDto  entities
     * @return Success
     */
    getAllAssessmentEntityByContentVersionByAssessmentSubjectEntities(): Observable<AssessmentEntityByContentVersionByAssessmentSubjectDto[]> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityByContentVersionByAssessmentSubject";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssessmentEntityByContentVersionByAssessmentSubjectEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssessmentEntityByContentVersionByAssessmentSubjectEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentEntityByContentVersionByAssessmentSubjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentEntityByContentVersionByAssessmentSubjectDto[]>;
        }));
    }

    protected processGetAllAssessmentEntityByContentVersionByAssessmentSubjectEntities(response: HttpResponseBase): Observable<AssessmentEntityByContentVersionByAssessmentSubjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentEntityByContentVersionByAssessmentSubjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAssessmentEntityByContentVersionByAssessmentSubject(body: AssessmentEntityByContentVersionByAssessmentSubjectDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityByContentVersionByAssessmentSubject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAssessmentEntityByContentVersionByAssessmentSubject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAssessmentEntityByContentVersionByAssessmentSubject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAssessmentEntityByContentVersionByAssessmentSubject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAssessmentEntityByContentVersionByAssessmentSubject(body: AssessmentEntityByContentVersionByAssessmentSubjectDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityByContentVersionByAssessmentSubject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAssessmentEntityByContentVersionByAssessmentSubject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAssessmentEntityByContentVersionByAssessmentSubject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAssessmentEntityByContentVersionByAssessmentSubject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAssessmentEntityByContentVersionByAssessmentSubject(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityByContentVersionByAssessmentSubject/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssessmentEntityByContentVersionByAssessmentSubject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssessmentEntityByContentVersionByAssessmentSubject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssessmentEntityByContentVersionByAssessmentSubject(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto  entities
     * @return Success
     */
    getAllAssessmentEntityTypeEntities(): Observable<AssessmentEntityTypeDto[]> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityType";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllAssessmentEntityTypeEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllAssessmentEntityTypeEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentEntityTypeDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentEntityTypeDto[]>;
        }));
    }

    protected processGetAllAssessmentEntityTypeEntities(response: HttpResponseBase): Observable<AssessmentEntityTypeDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentEntityTypeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postAssessmentEntityType(body: AssessmentEntityTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAssessmentEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAssessmentEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostAssessmentEntityType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putAssessmentEntityType(body: AssessmentEntityTypeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutAssessmentEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutAssessmentEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutAssessmentEntityType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteAssessmentEntityType(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/AssessmentEntityType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAssessmentEntityType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAssessmentEntityType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteAssessmentEntityType(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.BuildingAssessmentModelMatrixDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier
     * @return Success
     */
    getBuildingConfigurationByContentVersionId(contentVersionId: number): Observable<BuildingAssessmentModelMatrixDto[]> {
        let url_ = this.baseUrl + "/api/v1/BuildingConfiguration/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBuildingConfigurationByContentVersionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBuildingConfigurationByContentVersionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BuildingAssessmentModelMatrixDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BuildingAssessmentModelMatrixDto[]>;
        }));
    }

    protected processGetBuildingConfigurationByContentVersionId(response: HttpResponseBase): Observable<BuildingAssessmentModelMatrixDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BuildingAssessmentModelMatrixDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto  entities
     * @return Success
     */
    getAllCalculationCoreEntities(): Observable<CalculationCoreDto[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCore";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationCoreEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationCoreEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreDto[]>;
        }));
    }

    protected processGetAllCalculationCoreEntities(response: HttpResponseBase): Observable<CalculationCoreDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationCoreDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCore(body: CalculationCoreDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculationCore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculationCore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculationCore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCore(body: CalculationCoreDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCore";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationCore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationCore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationCore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreById(id: number): Observable<CalculationCoreDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationCoreById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationCoreById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreDto>;
        }));
    }

    protected processGetCalculationCoreById(response: HttpResponseBase): Observable<CalculationCoreDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationCoreDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCore(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCore/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculationCore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculationCore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculationCore(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all DataMemeber names that can be linked to a WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto
     * @param calculationCoreVersionId Unique identifier for the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto
     * @return Success
     */
    getRequestDataMemberNames(calculationCoreVersionId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCore/GetRequestDataMemberNames/{calculationCoreVersionId}";
        if (calculationCoreVersionId === undefined || calculationCoreVersionId === null)
            throw new globalThis.Error("The parameter 'calculationCoreVersionId' must be defined.");
        url_ = url_.replace("{calculationCoreVersionId}", encodeURIComponent("" + calculationCoreVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRequestDataMemberNames(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRequestDataMemberNames(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetRequestDataMemberNames(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto  entities
     * @return Success
     */
    getAllCalculationCoreExpressionEntities(): Observable<CalculationCoreExpressionDto[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreExpression";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationCoreExpressionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationCoreExpressionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreExpressionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreExpressionDto[]>;
        }));
    }

    protected processGetAllCalculationCoreExpressionEntities(response: HttpResponseBase): Observable<CalculationCoreExpressionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationCoreExpressionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreExpression(body: CalculationCoreExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculationCoreExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculationCoreExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculationCoreExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreExpression(body: CalculationCoreExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationCoreExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationCoreExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationCoreExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreExpressionById(id: number): Observable<CalculationCoreExpressionDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationCoreExpressionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationCoreExpressionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreExpressionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreExpressionDto>;
        }));
    }

    protected processGetCalculationCoreExpressionById(response: HttpResponseBase): Observable<CalculationCoreExpressionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationCoreExpressionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreExpression(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculationCoreExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculationCoreExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculationCoreExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto  entities
     * @return Success
     */
    getAllCalculationCoreResultExpressionEntities(): Observable<CalculationCoreResultExpressionDto[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpression";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationCoreResultExpressionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationCoreResultExpressionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreResultExpressionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreResultExpressionDto[]>;
        }));
    }

    protected processGetAllCalculationCoreResultExpressionEntities(response: HttpResponseBase): Observable<CalculationCoreResultExpressionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationCoreResultExpressionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreResultExpression(body: CalculationCoreResultExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculationCoreResultExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculationCoreResultExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculationCoreResultExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreResultExpression(body: CalculationCoreResultExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationCoreResultExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationCoreResultExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationCoreResultExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreResultExpressionById(id: number): Observable<CalculationCoreResultExpressionDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationCoreResultExpressionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationCoreResultExpressionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreResultExpressionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreResultExpressionDto>;
        }));
    }

    protected processGetCalculationCoreResultExpressionById(response: HttpResponseBase): Observable<CalculationCoreResultExpressionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationCoreResultExpressionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreResultExpression(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreResultExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculationCoreResultExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculationCoreResultExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculationCoreResultExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto  entities
     * @return Success
     */
    getAllCalculationCoreVersionEntities(): Observable<CalculationCoreVersionDto[]> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllCalculationCoreVersionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllCalculationCoreVersionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreVersionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreVersionDto[]>;
        }));
    }

    protected processGetAllCalculationCoreVersionEntities(response: HttpResponseBase): Observable<CalculationCoreVersionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalculationCoreVersionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postCalculationCoreVersion(body: CalculationCoreVersionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostCalculationCoreVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostCalculationCoreVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostCalculationCoreVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putCalculationCoreVersion(body: CalculationCoreVersionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutCalculationCoreVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutCalculationCoreVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutCalculationCoreVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getCalculationCoreVersionById(id: number): Observable<CalculationCoreVersionDto> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreVersion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCalculationCoreVersionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCalculationCoreVersionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculationCoreVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculationCoreVersionDto>;
        }));
    }

    protected processGetCalculationCoreVersionById(response: HttpResponseBase): Observable<CalculationCoreVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculationCoreVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteCalculationCoreVersion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/CalculationCoreVersion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCalculationCoreVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCalculationCoreVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteCalculationCoreVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ContentVersionDto  entities
     * @return Success
     */
    getAllContentVersionEntities(): Observable<ContentVersionDto[]> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllContentVersionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllContentVersionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentVersionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentVersionDto[]>;
        }));
    }

    protected processGetAllContentVersionEntities(response: HttpResponseBase): Observable<ContentVersionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ContentVersionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postContentVersion(body: ContentVersionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostContentVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putContentVersion(body: ContentVersionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutContentVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ContentVersionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getContentVersionById(id: number): Observable<ContentVersionDto> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentVersionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentVersionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentVersionDto>;
        }));
    }

    protected processGetContentVersionById(response: HttpResponseBase): Observable<ContentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteContentVersion(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteContentVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a collection of WE.AMP.Models.DataTransferObjects.ContentVersionDto for an WE.AMP.Models.DataTransferObjects.ApplicationDto
     * @param id Unique Identifier
     * @return Success
     */
    getContentVersionByApplication(id: number): Observable<ContentVersionDto> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion/byapplication/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetContentVersionByApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetContentVersionByApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentVersionDto>;
        }));
    }

    protected processGetContentVersionByApplication(response: HttpResponseBase): Observable<ContentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Copy of WE.AMP.Models.DataTransferObjects.ContentVersionDto for an WE.AMP.Models.DataTransferObjects.ApplicationDto
     * @param id Unique Identifier
     * @return Success
     */
    copyContentVersion(id: number): Observable<ContentVersionDto> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion/copy/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentVersionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentVersionDto>;
        }));
    }

    protected processCopyContentVersion(response: HttpResponseBase): Observable<ContentVersionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentVersionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Export of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    exportContentVersion(contentVersionId: number): Observable<ContentVersionExportDto> {
        let url_ = this.baseUrl + "/api/v1/ContentVersion/export/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportContentVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportContentVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContentVersionExportDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContentVersionExportDto>;
        }));
    }

    protected processExportContentVersion(response: HttpResponseBase): Observable<ContentVersionExportDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContentVersionExportDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Checks if the session is valid  for WE.AMP.Models.DataTransferObjects.ContentVersionDto  and WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto for that user WE.AMP.Models.DataTransferObjects.UserDto and perform actions on it
     * @return Created
     */
    getEditSessionBycontentVersionIdByeditSessionTypeId(contentVersionId: number, editSessionTypeId: number): Observable<EditSessionDto> {
        let url_ = this.baseUrl + "/api/v1/EditSession/{contentVersionId}/{editSessionTypeId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        if (editSessionTypeId === undefined || editSessionTypeId === null)
            throw new globalThis.Error("The parameter 'editSessionTypeId' must be defined.");
        url_ = url_.replace("{editSessionTypeId}", encodeURIComponent("" + editSessionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEditSessionBycontentVersionIdByeditSessionTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEditSessionBycontentVersionIdByeditSessionTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditSessionDto>;
        }));
    }

    protected processGetEditSessionBycontentVersionIdByeditSessionTypeId(response: HttpResponseBase): Observable<EditSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = EditSessionDto.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes an edit session for WE.AMP.Models.DataTransferObjects.ContentVersionDto and WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto for the logged in user WE.AMP.Models.DataTransferObjects.UserDto
     * @return No Content
     */
    deleteEditSessionBycontentVersionIdByeditSessionTypeId(contentVersionId: number, editSessionTypeId: number): Observable<EditSessionDto> {
        let url_ = this.baseUrl + "/api/v1/EditSession/{contentVersionId}/{editSessionTypeId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        if (editSessionTypeId === undefined || editSessionTypeId === null)
            throw new globalThis.Error("The parameter 'editSessionTypeId' must be defined.");
        url_ = url_.replace("{editSessionTypeId}", encodeURIComponent("" + editSessionTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEditSessionBycontentVersionIdByeditSessionTypeId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEditSessionBycontentVersionIdByeditSessionTypeId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EditSessionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EditSessionDto>;
        }));
    }

    protected processDeleteEditSessionBycontentVersionIdByeditSessionTypeId(response: HttpResponseBase): Observable<EditSessionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result204 = EditSessionDto.fromJS(resultData204);
            return _observableOf(result204);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postEditSession(body: EditSessionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EditSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostEditSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostEditSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostEditSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putEditSession(body: EditSessionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EditSession";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutEditSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutEditSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutEditSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteEditSession(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/EditSession/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteEditSession(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteEditSession(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteEditSession(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets unmapped single elements from WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getUnmappedSingleElements(contentVersionId: number): Observable<SelectBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Element/UnmappedSingle/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnmappedSingleElements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnmappedSingleElements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectBoxDto[]>;
        }));
    }

    protected processGetUnmappedSingleElements(response: HttpResponseBase): Observable<SelectBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get all WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto with related WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto for given WE.AMP.Models.DataTransferObjects.ContentVersionDto<param name="contentVersionId">unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto</param>
     * @return Success
     */
    getAllElement(contentVersionId: number): Observable<ElementDto[]> {
        let url_ = this.baseUrl + "/api/v1/Element/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementDto[]>;
        }));
    }

    protected processGetAllElement(response: HttpResponseBase): Observable<ElementDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto based on an unique identifier for given WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param id Unique identifier
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getElementById(id: number, contentVersionId: number): Observable<ElementDto> {
        let url_ = this.baseUrl + "/api/v1/Element/{id}/{contentVersionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementDto>;
        }));
    }

    protected processGetElementById(response: HttpResponseBase): Observable<ElementDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElementDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add new WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto<br>If WE.AMP.Models.DataTransferObjects.ProjectModel.ProjectModelDto.AddToTree is set to true then it will add WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto to WE.AMP.Models.DataTransferObjects.ContentVersionDto including child element and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDtoif specified
     * @param body (optional) Data Transfer Object for the adding WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto
     * @return Created
     */
    postElementSave(body: ProjectModelDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Element/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostElementSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostElementSave(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostElementSave(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param contentVersionId unique identifier or WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param body (optional) updated object for WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto
     * @return Success
     */
    putElementUpdate(contentVersionId: number, body: ElementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Element/Update/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutElementUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutElementUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutElementUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get's a list of child elements
     * @param elementByContentVersionId Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto
     * @return Success
     */
    getElementGetChildren(elementByContentVersionId: number): Observable<SelectBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Element/GetChildren/{elementByContentVersionId}";
        if (elementByContentVersionId === undefined || elementByContentVersionId === null)
            throw new globalThis.Error("The parameter 'elementByContentVersionId' must be defined.");
        url_ = url_.replace("{elementByContentVersionId}", encodeURIComponent("" + elementByContentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementGetChildren(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementGetChildren(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectBoxDto[]>;
        }));
    }

    protected processGetElementGetChildren(response: HttpResponseBase): Observable<SelectBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get list of root WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto in WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getElementGetRootElements(contentVersionId: number): Observable<SelectBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Element/GetRootElements/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementGetRootElements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementGetRootElements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectBoxDto[]>;
        }));
    }

    protected processGetElementGetRootElements(response: HttpResponseBase): Observable<SelectBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get element icons based on element type
     * @return Success
     */
    getElementGetIcons(elementTypeId: number): Observable<ImageIconSelectBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Element/GetIcons/{elementTypeId}";
        if (elementTypeId === undefined || elementTypeId === null)
            throw new globalThis.Error("The parameter 'elementTypeId' must be defined.");
        url_ = url_.replace("{elementTypeId}", encodeURIComponent("" + elementTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain; x-api-version=1.0"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementGetIcons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementGetIcons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ImageIconSelectBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ImageIconSelectBoxDto[]>;
        }));
    }

    protected processGetElementGetIcons(response: HttpResponseBase): Observable<ImageIconSelectBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ImageIconSelectBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postElement(body: ElementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Element";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostElement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putElement(body: ElementDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Element";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutElement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteElement(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Element/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteElement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteElement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteElement(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto  entities
     * @return Success
     */
    getAllElementOverrideEntities(): Observable<ElementOverrideDto[]> {
        let url_ = this.baseUrl + "/api/v1/ElementOverride";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllElementOverrideEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllElementOverrideEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementOverrideDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementOverrideDto[]>;
        }));
    }

    protected processGetAllElementOverrideEntities(response: HttpResponseBase): Observable<ElementOverrideDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ElementOverrideDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postElementOverride(body: ElementOverrideDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ElementOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostElementOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostElementOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostElementOverride(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putElementOverride(body: ElementOverrideDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ElementOverride";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutElementOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutElementOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutElementOverride(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getElementOverrideById(id: number): Observable<ElementOverrideDto> {
        let url_ = this.baseUrl + "/api/v1/ElementOverride/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetElementOverrideById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetElementOverrideById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ElementOverrideDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ElementOverrideDto>;
        }));
    }

    protected processGetElementOverrideById(response: HttpResponseBase): Observable<ElementOverrideDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ElementOverrideDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteElementOverride(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ElementOverride/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteElementOverride(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteElementOverride(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteElementOverride(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForFlatListDto entities with flags set whether the entities are or aren't used in the WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    entityForFlatListAssessmentModel(contentVersionId: number): Observable<AssessmentOrProjectModelEntityForFlatListDto[]> {
        let url_ = this.baseUrl + "/api/v1/EntityForFlatList/AssessmentModel/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityForFlatListAssessmentModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityForFlatListAssessmentModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentOrProjectModelEntityForFlatListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentOrProjectModelEntityForFlatListDto[]>;
        }));
    }

    protected processEntityForFlatListAssessmentModel(response: HttpResponseBase): Observable<AssessmentOrProjectModelEntityForFlatListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentOrProjectModelEntityForFlatListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForFlatListDto entities with flags set whether the entities are or aren't used in the WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    entityForFlatListProjectModel(contentVersionId: number): Observable<AssessmentOrProjectModelEntityForFlatListDto[]> {
        let url_ = this.baseUrl + "/api/v1/EntityForFlatList/ProjectModel/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEntityForFlatListProjectModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEntityForFlatListProjectModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentOrProjectModelEntityForFlatListDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentOrProjectModelEntityForFlatListDto[]>;
        }));
    }

    protected processEntityForFlatListProjectModel(response: HttpResponseBase): Observable<AssessmentOrProjectModelEntityForFlatListDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentOrProjectModelEntityForFlatListDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all possible values of AssessmentSubjectType for use in frontend selection
     * @return Success
     */
    getAssessmentSubjectTypes(): Observable<SmartEnumDto[]> {
        let url_ = this.baseUrl + "/api/v1/Enum/GetAssessmentSubjectTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssessmentSubjectTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssessmentSubjectTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SmartEnumDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SmartEnumDto[]>;
        }));
    }

    protected processGetAssessmentSubjectTypes(response: HttpResponseBase): Observable<SmartEnumDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SmartEnumDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto  entities
     * @return Success
     */
    getAllExpressionEntities(): Observable<ParameterToAssessmentExpressionDto[]> {
        let url_ = this.baseUrl + "/api/v1/Expression";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllExpressionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllExpressionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToAssessmentExpressionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToAssessmentExpressionDto[]>;
        }));
    }

    protected processGetAllExpressionEntities(response: HttpResponseBase): Observable<ParameterToAssessmentExpressionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterToAssessmentExpressionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postExpression(body: ParameterToAssessmentExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Expression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putExpression(body: ParameterToAssessmentExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Expression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getExpressionById(id: number): Observable<ParameterToAssessmentExpressionDto> {
        let url_ = this.baseUrl + "/api/v1/Expression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpressionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpressionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToAssessmentExpressionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToAssessmentExpressionDto>;
        }));
    }

    protected processGetExpressionById(response: HttpResponseBase): Observable<ParameterToAssessmentExpressionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterToAssessmentExpressionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteExpression(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Expression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a collection of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto based on an unique identifier for a WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique identifier of a WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getExpressionByContentVersionId(contentVersionId: number): Observable<ParameterToAssessmentExpressionDto[]> {
        let url_ = this.baseUrl + "/api/v1/Expression/ByContentVersion/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpressionByContentVersionId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpressionByContentVersionId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToAssessmentExpressionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToAssessmentExpressionDto[]>;
        }));
    }

    protected processGetExpressionByContentVersionId(response: HttpResponseBase): Observable<ParameterToAssessmentExpressionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterToAssessmentExpressionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes the relation to (mapping of) WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto from WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto
     * @param expressionId Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto
     * @return Success
     */
    deleteExpressionRemoveRelationToAssessmentEntity(expressionId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Expression/RemoveRelation/{expressionId}";
        if (expressionId === undefined || expressionId === null)
            throw new globalThis.Error("The parameter 'expressionId' must be defined.");
        url_ = url_.replace("{expressionId}", encodeURIComponent("" + expressionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteExpressionRemoveRelationToAssessmentEntity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteExpressionRemoveRelationToAssessmentEntity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteExpressionRemoveRelationToAssessmentEntity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Check if the given expression is valid or invalid
     * @param body (optional) 
     * @return Success
     */
    validateExpressionExpression(body: string | undefined): Observable<ParameterToAssessmentExpressionDto[]> {
        let url_ = this.baseUrl + "/api/v1/Expression/validateExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
                "Accept": "text/plain; x-api-version=1.0"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateExpressionExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateExpressionExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterToAssessmentExpressionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterToAssessmentExpressionDto[]>;
        }));
    }

    protected processValidateExpressionExpression(response: HttpResponseBase): Observable<ParameterToAssessmentExpressionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterToAssessmentExpressionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a tree ofWE.AMP.Models.DataTransferObjects.FormlyModel.FormlyProjectModelTreeDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier WE.AMP.Models.Entities.ContentVersion
     * @return Success
     */
    formlyModel(contentVersionId: number): Observable<FormlyProjectModelTreeDto> {
        let url_ = this.baseUrl + "/api/v1/Formly/FormlyModel/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormlyModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormlyModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormlyProjectModelTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormlyProjectModelTreeDto>;
        }));
    }

    protected processFormlyModel(response: HttpResponseBase): Observable<FormlyProjectModelTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormlyProjectModelTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save user inputs from the Assessment Model Matrix
     * @param contentVersionId (optional) user input for model matrix
     * @return Success
     */
    getMatrix(contentVersionId: number | undefined): Observable<AssessmentModelMatrixDto[]> {
        let url_ = this.baseUrl + "/api/v1/Matrix/Get?";
        if (contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' cannot be null.");
        else if (contentVersionId !== undefined)
            url_ += "contentVersionId=" + encodeURIComponent("" + contentVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain; x-api-version=1.0"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatrix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatrix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssessmentModelMatrixDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssessmentModelMatrixDto[]>;
        }));
    }

    protected processGetMatrix(response: HttpResponseBase): Observable<AssessmentModelMatrixDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssessmentModelMatrixDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save user inputs from the Assessment Model Matrix
     * @param body (optional) user input for model matrix
     * @return Created
     */
    saveMatrix(body: AssessmentEntityByContentVersionDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Matrix/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveMatrix(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveMatrix(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveMatrix(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier
     * @return Success
     */
    modelTreeAssessmentModel(contentVersionId: number): Observable<ModelTreeDto> {
        let url_ = this.baseUrl + "/api/v1/ModelTree/AssessmentModel/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModelTreeAssessmentModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModelTreeAssessmentModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModelTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModelTreeDto>;
        }));
    }

    protected processModelTreeAssessmentModel(response: HttpResponseBase): Observable<ModelTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and its WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto based on WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param contentVersionId Unique Identifier
     * @return Success
     */
    modelTreeProjectModel(contentVersionId: number): Observable<ModelTreeDto> {
        let url_ = this.baseUrl + "/api/v1/ModelTree/ProjectModel/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModelTreeProjectModel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModelTreeProjectModel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ModelTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ModelTreeDto>;
        }));
    }

    protected processModelTreeProjectModel(response: HttpResponseBase): Observable<ModelTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ModelTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Save changes to the WE.AMP.Models.DataTransferObjects.ModelTreeDto
     * @param body (optional) Data Transfer Object for the tree
     * @return Created
     */
    saveModelTreeTree(body: ModelTreeDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ModelTree/SaveTree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveModelTreeTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveModelTreeTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSaveModelTreeTree(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto with WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    modelTreeGetAssessmentModelTreeWithExpressions(contentVersionId: number): Observable<ExpressionModelTreeDto> {
        let url_ = this.baseUrl + "/api/v1/ModelTree/GetAssessmentModelTreeWithExpressions/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModelTreeGetAssessmentModelTreeWithExpressions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModelTreeGetAssessmentModelTreeWithExpressions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExpressionModelTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExpressionModelTreeDto>;
        }));
    }

    protected processModelTreeGetAssessmentModelTreeWithExpressions(response: HttpResponseBase): Observable<ExpressionModelTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpressionModelTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a tree ofWE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto for expression
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    modelTreeGetProjectModelTreeForExpression(contentVersionId: number): Observable<ExpressionModelTreeDto> {
        let url_ = this.baseUrl + "/api/v1/ModelTree/GetProjectModelTreeForExpression/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModelTreeGetProjectModelTreeForExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModelTreeGetProjectModelTreeForExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExpressionModelTreeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExpressionModelTreeDto>;
        }));
    }

    protected processModelTreeGetProjectModelTreeForExpression(response: HttpResponseBase): Observable<ExpressionModelTreeDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExpressionModelTreeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.OrganizationDto  entities
     * @return Success
     */
    getAllOrganizationEntities(): Observable<OrganizationDto[]> {
        let url_ = this.baseUrl + "/api/v1/Organization";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllOrganizationEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllOrganizationEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto[]>;
        }));
    }

    protected processGetAllOrganizationEntities(response: HttpResponseBase): Observable<OrganizationDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postOrganization(body: OrganizationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostOrganization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putOrganization(body: OrganizationDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Organization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutOrganization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.OrganizationDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getOrganizationById(id: number): Observable<OrganizationDto> {
        let url_ = this.baseUrl + "/api/v1/Organization/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrganizationById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrganizationById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OrganizationDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OrganizationDto>;
        }));
    }

    protected processGetOrganizationById(response: HttpResponseBase): Observable<OrganizationDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteOrganization(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Organization/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteOrganization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteOrganization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteOrganization(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto  entities for given WE.AMP.Models.DataTransferObjects.ContentVersionDto<param name="contentVersionId">unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto</param>
     * @return Success
     */
    getAllParameterEntities(contentVersionId: number): Observable<ParameterDto[]> {
        let url_ = this.baseUrl + "/api/v1/Parameter/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParameterEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParameterEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterDto[]>;
        }));
    }

    protected processGetAllParameterEntities(response: HttpResponseBase): Observable<ParameterDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto from WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getParameters(contentVersionId: number): Observable<SelectBoxDto[]> {
        let url_ = this.baseUrl + "/api/v1/Parameter/Parameters/{contentVersionId}";
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SelectBoxDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SelectBoxDto[]>;
        }));
    }

    protected processGetParameters(response: HttpResponseBase): Observable<SelectBoxDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SelectBoxDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto based on an unique identifier for given WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param id Unique identifier
     * @param contentVersionId unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @return Success
     */
    getParameterById(id: number, contentVersionId: number): Observable<ParameterDto> {
        let url_ = this.baseUrl + "/api/v1/Parameter/{id}/{contentVersionId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contentVersionId === undefined || contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' must be defined.");
        url_ = url_.replace("{contentVersionId}", encodeURIComponent("" + contentVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterDto>;
        }));
    }

    protected processGetParameterById(response: HttpResponseBase): Observable<ParameterDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param contentVersionId (optional) unique identifier or WE.AMP.Models.DataTransferObjects.ContentVersionDto
     * @param body (optional) updated object for WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto
     * @return Success
     */
    putParameterUpdate(contentVersionId: number | undefined, body: ParameterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Parameter/Update?";
        if (contentVersionId === null)
            throw new globalThis.Error("The parameter 'contentVersionId' cannot be null.");
        else if (contentVersionId !== undefined)
            url_ += "contentVersionId=" + encodeURIComponent("" + contentVersionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutParameterUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutParameterUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutParameterUpdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new parameter
     * @param body (optional) 
     * @return Created
     */
    postParameter(body: ParameterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Parameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostParameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostParameter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameter(body: ParameterDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Parameter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutParameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutParameter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameter(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Parameter/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParameter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParameter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParameter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto  entities
     * @return Success
     */
    getAllParameterByCalculationCoreExpressionEntities(): Observable<ParameterByCalculationCoreExpressionDto[]> {
        let url_ = this.baseUrl + "/api/v1/ParameterByCalculationCoreExpression";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParameterByCalculationCoreExpressionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParameterByCalculationCoreExpressionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterByCalculationCoreExpressionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterByCalculationCoreExpressionDto[]>;
        }));
    }

    protected processGetAllParameterByCalculationCoreExpressionEntities(response: HttpResponseBase): Observable<ParameterByCalculationCoreExpressionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterByCalculationCoreExpressionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterByCalculationCoreExpression(body: ParameterByCalculationCoreExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterByCalculationCoreExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostParameterByCalculationCoreExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostParameterByCalculationCoreExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostParameterByCalculationCoreExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterByCalculationCoreExpression(body: ParameterByCalculationCoreExpressionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterByCalculationCoreExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutParameterByCalculationCoreExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutParameterByCalculationCoreExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutParameterByCalculationCoreExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getParameterByCalculationCoreExpressionById(id: number): Observable<ParameterByCalculationCoreExpressionDto> {
        let url_ = this.baseUrl + "/api/v1/ParameterByCalculationCoreExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterByCalculationCoreExpressionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterByCalculationCoreExpressionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterByCalculationCoreExpressionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterByCalculationCoreExpressionDto>;
        }));
    }

    protected processGetParameterByCalculationCoreExpressionById(response: HttpResponseBase): Observable<ParameterByCalculationCoreExpressionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterByCalculationCoreExpressionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterByCalculationCoreExpression(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterByCalculationCoreExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParameterByCalculationCoreExpression(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParameterByCalculationCoreExpression(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParameterByCalculationCoreExpression(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto  entities
     * @return Success
     */
    getAllParameterOptionEntities(): Observable<ParameterOptionDto[]> {
        let url_ = this.baseUrl + "/api/v1/ParameterOption";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllParameterOptionEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllParameterOptionEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterOptionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterOptionDto[]>;
        }));
    }

    protected processGetAllParameterOptionEntities(response: HttpResponseBase): Observable<ParameterOptionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ParameterOptionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Add a new entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Created
     */
    postParameterOption(body: ParameterOptionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostParameterOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostParameterOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostParameterOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putParameterOption(body: ParameterOptionDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutParameterOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutParameterOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutParameterOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getParameterOptionById(id: number): Observable<ParameterOptionDto> {
        let url_ = this.baseUrl + "/api/v1/ParameterOption/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetParameterOptionById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetParameterOptionById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ParameterOptionDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ParameterOptionDto>;
        }));
    }

    protected processGetParameterOptionById(response: HttpResponseBase): Observable<ParameterOptionDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ParameterOptionDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteParameterOption(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/ParameterOption/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteParameterOption(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteParameterOption(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteParameterOption(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.FormlyModel.PatternDto entities
     * @return Success
     */
    getAllPatternEntities(): Observable<PatternDto[]> {
        let url_ = this.baseUrl + "/api/v1/Pattern";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPatternEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPatternEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatternDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatternDto[]>;
        }));
    }

    protected processGetAllPatternEntities(response: HttpResponseBase): Observable<PatternDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatternDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postPattern(body: PatternDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Pattern";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPattern(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostPattern(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putPattern(body: PatternDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Pattern";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPattern(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutPattern(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.FormlyModel.PatternDto   based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getPatternById(id: number): Observable<PatternDto[]> {
        let url_ = this.baseUrl + "/api/v1/Pattern/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPatternById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPatternById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PatternDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PatternDto[]>;
        }));
    }

    protected processGetPatternById(response: HttpResponseBase): Observable<PatternDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PatternDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deletePattern(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Pattern/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePattern(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePattern(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeletePattern(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto entities
     * @return Success
     */
    getAllTemplateOptionsEntities(): Observable<TemplateOptionsDto[]> {
        let url_ = this.baseUrl + "/api/v1/TemplateOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTemplateOptionsEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTemplateOptionsEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateOptionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateOptionsDto[]>;
        }));
    }

    protected processGetAllTemplateOptionsEntities(response: HttpResponseBase): Observable<TemplateOptionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateOptionsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postTemplateOptions(body: TemplateOptionsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/TemplateOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTemplateOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTemplateOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostTemplateOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putTemplateOptions(body: TemplateOptionsDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/TemplateOptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutTemplateOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutTemplateOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutTemplateOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto   based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getTemplateOptionsById(id: number): Observable<TemplateOptionsDto[]> {
        let url_ = this.baseUrl + "/api/v1/TemplateOptions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemplateOptionsById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemplateOptionsById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TemplateOptionsDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TemplateOptionsDto[]>;
        }));
    }

    protected processGetTemplateOptionsById(response: HttpResponseBase): Observable<TemplateOptionsDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TemplateOptionsDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteTemplateOptions(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/TemplateOptions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTemplateOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTemplateOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteTemplateOptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.UnitDto  entities
     * @return Success
     */
    getAllUnitEntities(): Observable<UnitDto[]> {
        let url_ = this.baseUrl + "/api/v1/Unit";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUnitEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUnitEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitDto[]>;
        }));
    }

    protected processGetAllUnitEntities(response: HttpResponseBase): Observable<UnitDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnitDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postUnit(body: UnitDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putUnit(body: UnitDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Unit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.UnitDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getUnitById(id: number): Observable<UnitDto> {
        let url_ = this.baseUrl + "/api/v1/Unit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnitById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnitById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UnitDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UnitDto>;
        }));
    }

    protected processGetUnitById(response: HttpResponseBase): Observable<UnitDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UnitDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteUnit(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/Unit/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUnit(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUnit(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUnit(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Gets all WE.AMP.Models.DataTransferObjects.UserDto  entities
     * @return Success
     */
    getAllUserEntities(): Observable<UserDto[]> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUserEntities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUserEntities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto[]>;
        }));
    }

    protected processGetAllUserEntities(response: HttpResponseBase): Observable<UserDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return Created
     */
    postUser(body: UserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update an existing entity
     * @param body (optional) Data Transfer Object for the entity
     * @return Success
     */
    putUser(body: UserDto | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json; x-api-version=1.0",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPutUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get a specific WE.AMP.Models.DataTransferObjects.UserDto based on an unique identifier
     * @param id Unique identifier
     * @return Success
     */
    getUserById(id: number): Observable<UserDto> {
        let url_ = this.baseUrl + "/api/v1/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserDto>;
        }));
    }

    protected processGetUserById(response: HttpResponseBase): Observable<UserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Removes an entity from the database
     * @param id Unique Identifier
     * @return No Content
     */
    deleteUser(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/v1/User/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ApplicationDto like WE.AMP.Models.DataTransferObjects.ApplicationDto.Name, WE.AMP.Models.DataTransferObjects.ApplicationDto.Description <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.ApplicationDto, update existing ones or get data from the database in this structure */
export class ApplicationDto implements IApplicationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Name of the entity */
    name!: string;
    /** Gets or sets the unique key. */
    key!: string;
    /** Gets or sets the Description of the entity */
    description?: string | undefined;
    /** Gets or sets the Image of the entity */
    image?: string | undefined;
    /** Gets or sets the BrandLogo of the entity */
    brandLogo?: string | undefined;
    /** Gets or sets the Date and time of when this WE.AMP.Models.DataTransferObjects.ApplicationDto was published last */
    lastPublishedDate?: Date | undefined;
    /** Gets or sets the unique identifier */
    createdById?: number;
    createdBy?: UserDto;
    /** Gets or sets the ModifiedById */
    modifiedById?: number | undefined;
    modifiedBy?: UserDto;
    /** Gets or sets the LastPublishedById */
    lastPublishedById?: number | undefined;
    lastPublishedBy?: UserDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersions?: ContentVersionDto[] | undefined;
    /** Gets or sets the Domain url of application */
    domainUrl?: string | undefined;
    /** Gets or sets the NoCalculation flag
<br>If application cannot have calculation then flag is set to true */
    noCalculations?: boolean;
    /** Gets or set the GprLicentiebeheerAppId
<br>This is the application Id set in Licentiebeheer */
    gprLicentiebeheerAppId?: number | undefined;

    constructor(data?: IApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.description = _data["description"];
            this.image = _data["image"];
            this.brandLogo = _data["brandLogo"];
            this.lastPublishedDate = _data["lastPublishedDate"] ? new Date(_data["lastPublishedDate"].toString()) : undefined as any;
            this.createdById = _data["createdById"];
            this.createdBy = _data["createdBy"] ? UserDto.fromJS(_data["createdBy"]) : undefined as any;
            this.modifiedById = _data["modifiedById"];
            this.modifiedBy = _data["modifiedBy"] ? UserDto.fromJS(_data["modifiedBy"]) : undefined as any;
            this.lastPublishedById = _data["lastPublishedById"];
            this.lastPublishedBy = _data["lastPublishedBy"] ? UserDto.fromJS(_data["lastPublishedBy"]) : undefined as any;
            if (Array.isArray(_data["contentVersions"])) {
                this.contentVersions = [] as any;
                for (let item of _data["contentVersions"])
                    this.contentVersions!.push(ContentVersionDto.fromJS(item));
            }
            this.domainUrl = _data["domainUrl"];
            this.noCalculations = _data["noCalculations"];
            this.gprLicentiebeheerAppId = _data["gprLicentiebeheerAppId"];
        }
    }

    static fromJS(data: any): ApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["description"] = this.description;
        data["image"] = this.image;
        data["brandLogo"] = this.brandLogo;
        data["lastPublishedDate"] = this.lastPublishedDate ? this.lastPublishedDate.toISOString() : undefined as any;
        data["createdById"] = this.createdById;
        data["createdBy"] = this.createdBy ? this.createdBy.toJSON() : undefined as any;
        data["modifiedById"] = this.modifiedById;
        data["modifiedBy"] = this.modifiedBy ? this.modifiedBy.toJSON() : undefined as any;
        data["lastPublishedById"] = this.lastPublishedById;
        data["lastPublishedBy"] = this.lastPublishedBy ? this.lastPublishedBy.toJSON() : undefined as any;
        if (Array.isArray(this.contentVersions)) {
            data["contentVersions"] = [];
            for (let item of this.contentVersions)
                data["contentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        data["domainUrl"] = this.domainUrl;
        data["noCalculations"] = this.noCalculations;
        data["gprLicentiebeheerAppId"] = this.gprLicentiebeheerAppId;
        return data;
    }
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ApplicationDto like WE.AMP.Models.DataTransferObjects.ApplicationDto.Name, WE.AMP.Models.DataTransferObjects.ApplicationDto.Description <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.ApplicationDto, update existing ones or get data from the database in this structure */
export interface IApplicationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Name of the entity */
    name: string;
    /** Gets or sets the unique key. */
    key: string;
    /** Gets or sets the Description of the entity */
    description?: string | undefined;
    /** Gets or sets the Image of the entity */
    image?: string | undefined;
    /** Gets or sets the BrandLogo of the entity */
    brandLogo?: string | undefined;
    /** Gets or sets the Date and time of when this WE.AMP.Models.DataTransferObjects.ApplicationDto was published last */
    lastPublishedDate?: Date | undefined;
    /** Gets or sets the unique identifier */
    createdById?: number;
    createdBy?: UserDto;
    /** Gets or sets the ModifiedById */
    modifiedById?: number | undefined;
    modifiedBy?: UserDto;
    /** Gets or sets the LastPublishedById */
    lastPublishedById?: number | undefined;
    lastPublishedBy?: UserDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersions?: ContentVersionDto[] | undefined;
    /** Gets or sets the Domain url of application */
    domainUrl?: string | undefined;
    /** Gets or sets the NoCalculation flag
<br>If application cannot have calculation then flag is set to true */
    noCalculations?: boolean;
    /** Gets or set the GprLicentiebeheerAppId
<br>This is the application Id set in Licentiebeheer */
    gprLicentiebeheerAppId?: number | undefined;
}

/** <br>Gets or sets the relation between an WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto, Assessment Subject Type and adds WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionByAssessmentSubjectDto.Weight to that relation <br>Can be used to create a new entity, update existing ones or get entities from the database in this structure */
export class AssessmentEntityByContentVersionByAssessmentSubjectDto implements IAssessmentEntityByContentVersionByAssessmentSubjectDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or Sets the Weight */
    weight?: number | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionId!: number;
    /** Gets or sets the assessment subject type Id based on WE.GPR.Connections.Models.Enums.BuildingUseFunctionEnum */
    assessmentSubjectTypeId!: number;

    constructor(data?: IAssessmentEntityByContentVersionByAssessmentSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.weight = _data["weight"];
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.assessmentSubjectTypeId = _data["assessmentSubjectTypeId"];
        }
    }

    static fromJS(data: any): AssessmentEntityByContentVersionByAssessmentSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityByContentVersionByAssessmentSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["weight"] = this.weight;
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["assessmentSubjectTypeId"] = this.assessmentSubjectTypeId;
        return data;
    }
}

/** <br>Gets or sets the relation between an WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto, Assessment Subject Type and adds WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionByAssessmentSubjectDto.Weight to that relation <br>Can be used to create a new entity, update existing ones or get entities from the database in this structure */
export interface IAssessmentEntityByContentVersionByAssessmentSubjectDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or Sets the Weight */
    weight?: number | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionId: number;
    /** Gets or sets the assessment subject type Id based on WE.GPR.Connections.Models.Enums.BuildingUseFunctionEnum */
    assessmentSubjectTypeId: number;
}

/** <br>Gets or sets the properties for a relation between WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto and WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to get a single or list of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto that are linked to a WE.AMP.Models.DataTransferObjects.ContentVersionDto */
export class AssessmentEntityByContentVersionDto implements IAssessmentEntityByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the order of an WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto in the WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    order?: number;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId!: number;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for new building configuration */
    isNewBuilding?: boolean;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for existing building configuration */
    isExistingBuilding?: boolean;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
    assessmentEntityId!: number;
    /** Gets or sets the collection of assessment subjects that are linked to this WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionByAssessmentSubjects?: AssessmentEntityByContentVersionByAssessmentSubjectDto[] | undefined;

    constructor(data?: IAssessmentEntityByContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.order = _data["order"];
            this.contentVersionId = _data["contentVersionId"];
            this.isNewBuilding = _data["isNewBuilding"];
            this.isExistingBuilding = _data["isExistingBuilding"];
            this.assessmentEntityId = _data["assessmentEntityId"];
            if (Array.isArray(_data["assessmentEntityByContentVersionByAssessmentSubjects"])) {
                this.assessmentEntityByContentVersionByAssessmentSubjects = [] as any;
                for (let item of _data["assessmentEntityByContentVersionByAssessmentSubjects"])
                    this.assessmentEntityByContentVersionByAssessmentSubjects!.push(AssessmentEntityByContentVersionByAssessmentSubjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentEntityByContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityByContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["order"] = this.order;
        data["contentVersionId"] = this.contentVersionId;
        data["isNewBuilding"] = this.isNewBuilding;
        data["isExistingBuilding"] = this.isExistingBuilding;
        data["assessmentEntityId"] = this.assessmentEntityId;
        if (Array.isArray(this.assessmentEntityByContentVersionByAssessmentSubjects)) {
            data["assessmentEntityByContentVersionByAssessmentSubjects"] = [];
            for (let item of this.assessmentEntityByContentVersionByAssessmentSubjects)
                data["assessmentEntityByContentVersionByAssessmentSubjects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the properties for a relation between WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto and WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to get a single or list of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto that are linked to a WE.AMP.Models.DataTransferObjects.ContentVersionDto */
export interface IAssessmentEntityByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the order of an WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto in the WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    order?: number;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId: number;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for new building configuration */
    isNewBuilding?: boolean;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for existing building configuration */
    isExistingBuilding?: boolean;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
    assessmentEntityId: number;
    /** Gets or sets the collection of assessment subjects that are linked to this WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionByAssessmentSubjects?: AssessmentEntityByContentVersionByAssessmentSubjectDto[] | undefined;
}

/** Export dto for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
export class AssessmentEntityByContentVersionExportDto implements IAssessmentEntityByContentVersionExportDto {
    /** Gets or sets the order of an WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto in the WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    order?: number;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for new building configuration */
    isNewBuilding?: boolean;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for existing building configuration */
    isExistingBuilding?: boolean;
    /** Gets or sets the collection of assessment subjects that are linked to this WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentSubjects?: AssessmentSubjectExportDto[] | undefined;

    constructor(data?: IAssessmentEntityByContentVersionExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.order = _data["order"];
            this.isNewBuilding = _data["isNewBuilding"];
            this.isExistingBuilding = _data["isExistingBuilding"];
            if (Array.isArray(_data["assessmentSubjects"])) {
                this.assessmentSubjects = [] as any;
                for (let item of _data["assessmentSubjects"])
                    this.assessmentSubjects!.push(AssessmentSubjectExportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentEntityByContentVersionExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityByContentVersionExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order;
        data["isNewBuilding"] = this.isNewBuilding;
        data["isExistingBuilding"] = this.isExistingBuilding;
        if (Array.isArray(this.assessmentSubjects)) {
            data["assessmentSubjects"] = [];
            for (let item of this.assessmentSubjects)
                data["assessmentSubjects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Export dto for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
export interface IAssessmentEntityByContentVersionExportDto {
    /** Gets or sets the order of an WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto in the WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    order?: number;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for new building configuration */
    isNewBuilding?: boolean;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for existing building configuration */
    isExistingBuilding?: boolean;
    /** Gets or sets the collection of assessment subjects that are linked to this WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentSubjects?: AssessmentSubjectExportDto[] | undefined;
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto.Text, its WE.AMP.Models.Entities.AssessmentModel.AssessmentEntityType, etc. <br>Can be used to create a new property, update existing ones or get entities from the database in this structure */
export class AssessmentEntityDto implements IAssessmentEntityDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Unique key for this entity. */
    key?: string;
    /** Gets or sets the Name (theme, subtheme or cluster) or Description (MeasureGroup) */
    text!: string;
    /** Gets or sets The Unique identifier of the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto (1 theme, 2 sub theme, 3 cluster or 4 MeasureGroup) */
    assessmentEntityTypeId!: number;
    /** Gets or sets the external url. */
    externalUrl?: string | undefined;
    assessmentEntityExtension?: AssessmentEntityExtensionDto;
    /** Manual sections linked to this AssessmentEntity, together they form the help text shown behind the i-icon in the UI */
    manualSections?: AssessmentEntityManualSectionDto[] | undefined;

    constructor(data?: IAssessmentEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.text = _data["text"];
            this.assessmentEntityTypeId = _data["assessmentEntityTypeId"];
            this.externalUrl = _data["externalUrl"];
            this.assessmentEntityExtension = _data["assessmentEntityExtension"] ? AssessmentEntityExtensionDto.fromJS(_data["assessmentEntityExtension"]) : undefined as any;
            if (Array.isArray(_data["manualSections"])) {
                this.manualSections = [] as any;
                for (let item of _data["manualSections"])
                    this.manualSections!.push(AssessmentEntityManualSectionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["text"] = this.text;
        data["assessmentEntityTypeId"] = this.assessmentEntityTypeId;
        data["externalUrl"] = this.externalUrl;
        data["assessmentEntityExtension"] = this.assessmentEntityExtension ? this.assessmentEntityExtension.toJSON() : undefined as any;
        if (Array.isArray(this.manualSections)) {
            data["manualSections"] = [];
            for (let item of this.manualSections)
                data["manualSections"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto.Text, its WE.AMP.Models.Entities.AssessmentModel.AssessmentEntityType, etc. <br>Can be used to create a new property, update existing ones or get entities from the database in this structure */
export interface IAssessmentEntityDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Unique key for this entity. */
    key?: string;
    /** Gets or sets the Name (theme, subtheme or cluster) or Description (MeasureGroup) */
    text: string;
    /** Gets or sets The Unique identifier of the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto (1 theme, 2 sub theme, 3 cluster or 4 MeasureGroup) */
    assessmentEntityTypeId: number;
    /** Gets or sets the external url. */
    externalUrl?: string | undefined;
    assessmentEntityExtension?: AssessmentEntityExtensionDto;
    /** Manual sections linked to this AssessmentEntity, together they form the help text shown behind the i-icon in the UI */
    manualSections?: AssessmentEntityManualSectionDto[] | undefined;
}

/** dto class to hold additional fields for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
export class AssessmentEntityExtensionDto implements IAssessmentEntityExtensionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Unique Identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
    assessmentEntityId?: number;
    /** Gets or sets  WE.GPR.Connections.Models.Enums.AssessmentEntitySubTypeEnum */
    assessmentEntitySubTypeId?: number | undefined;
    /** Gets or sets the maximum points that can be assigned to the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like ForkOption */
    maximumPoints?: number | undefined;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto as WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum.Theme
This is used to link the to a specific theme. */
    dependentThemeId?: number | undefined;

    constructor(data?: IAssessmentEntityExtensionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.assessmentEntityId = _data["assessmentEntityId"];
            this.assessmentEntitySubTypeId = _data["assessmentEntitySubTypeId"];
            this.maximumPoints = _data["maximumPoints"];
            this.dependentThemeId = _data["dependentThemeId"];
        }
    }

    static fromJS(data: any): AssessmentEntityExtensionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityExtensionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["assessmentEntityId"] = this.assessmentEntityId;
        data["assessmentEntitySubTypeId"] = this.assessmentEntitySubTypeId;
        data["maximumPoints"] = this.maximumPoints;
        data["dependentThemeId"] = this.dependentThemeId;
        return data;
    }
}

/** dto class to hold additional fields for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
export interface IAssessmentEntityExtensionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Unique Identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
    assessmentEntityId?: number;
    /** Gets or sets  WE.GPR.Connections.Models.Enums.AssessmentEntitySubTypeEnum */
    assessmentEntitySubTypeId?: number | undefined;
    /** Gets or sets the maximum points that can be assigned to the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like ForkOption */
    maximumPoints?: number | undefined;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto as WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum.Theme
This is used to link the to a specific theme. */
    dependentThemeId?: number | undefined;
}

/** Represents a single manual section for an AssessmentEntity. */
export class AssessmentEntityManualSectionDto implements IAssessmentEntityManualSectionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** FK to AssessmentEntity (int Id) */
    assessmentEntityId?: number;
    /** Index of the manual section to determine its order. */
    sectionIndex?: number;
    /** HTML content for this section. Stored as nvarchar(max). */
    content?: string | undefined;

    constructor(data?: IAssessmentEntityManualSectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.assessmentEntityId = _data["assessmentEntityId"];
            this.sectionIndex = _data["sectionIndex"];
            this.content = _data["content"];
        }
    }

    static fromJS(data: any): AssessmentEntityManualSectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityManualSectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["assessmentEntityId"] = this.assessmentEntityId;
        data["sectionIndex"] = this.sectionIndex;
        data["content"] = this.content;
        return data;
    }
}

/** Represents a single manual section for an AssessmentEntity. */
export interface IAssessmentEntityManualSectionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** FK to AssessmentEntity (int Id) */
    assessmentEntityId?: number;
    /** Index of the manual section to determine its order. */
    sectionIndex?: number;
    /** HTML content for this section. Stored as nvarchar(max). */
    content?: string | undefined;
}

/** <br>Get or sets the type of the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto <br>Used to describe whether the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto is a Theme, SubTheme, etc. */
export class AssessmentEntityTypeDto implements IAssessmentEntityTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the value of the type, so Theme, SubTheme, etc. */
    value!: string;
    /** Gets or sets whether this type can only be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets whether this type should not be used for numbering, for instance clusters will have this set to true */
    isNotForNumbering?: boolean;
    /** True, if AssessmentEntityType is for MeasureGroup */
    canBeLinkedMultipleTimes?: boolean;
    /** Gets or sets Font awesome icon classess for assessment entity */
    faIconClassess?: string | undefined;
    /** Gets or sets the can have expression */
    canHaveExpression?: boolean;
    /** The list of Ids of reference to the parent of this entity */
    readonly referencedParentIds?: number[] | undefined;

    constructor(data?: IAssessmentEntityTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.isRoot = _data["isRoot"];
            this.isNotForNumbering = _data["isNotForNumbering"];
            this.canBeLinkedMultipleTimes = _data["canBeLinkedMultipleTimes"];
            this.faIconClassess = _data["faIconClassess"];
            this.canHaveExpression = _data["canHaveExpression"];
            if (Array.isArray(_data["referencedParentIds"])) {
                (this as any).referencedParentIds = [] as any;
                for (let item of _data["referencedParentIds"])
                    (this as any).referencedParentIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AssessmentEntityTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentEntityTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["isRoot"] = this.isRoot;
        data["isNotForNumbering"] = this.isNotForNumbering;
        data["canBeLinkedMultipleTimes"] = this.canBeLinkedMultipleTimes;
        data["faIconClassess"] = this.faIconClassess;
        data["canHaveExpression"] = this.canHaveExpression;
        if (Array.isArray(this.referencedParentIds)) {
            data["referencedParentIds"] = [];
            for (let item of this.referencedParentIds)
                data["referencedParentIds"].push(item);
        }
        return data;
    }
}

/** <br>Get or sets the type of the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto <br>Used to describe whether the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto is a Theme, SubTheme, etc. */
export interface IAssessmentEntityTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the value of the type, so Theme, SubTheme, etc. */
    value: string;
    /** Gets or sets whether this type can only be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets whether this type should not be used for numbering, for instance clusters will have this set to true */
    isNotForNumbering?: boolean;
    /** True, if AssessmentEntityType is for MeasureGroup */
    canBeLinkedMultipleTimes?: boolean;
    /** Gets or sets Font awesome icon classess for assessment entity */
    faIconClassess?: string | undefined;
    /** Gets or sets the can have expression */
    canHaveExpression?: boolean;
    /** The list of Ids of reference to the parent of this entity */
    referencedParentIds?: number[] | undefined;
}

/** Export dto for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto details in given content version */
export class AssessmentModelExportDto implements IAssessmentModelExportDto {
    /** Unique key for this entity. */
    key?: string;
    /** Gets or sets the Name (theme, subtheme or cluster) or Description (MeasureGroup) */
    text?: string | undefined;
    /** A collection of manual HTML like the Help text from a MeasureGroup */
    manualSections?: AssessmentEntityManualSectionDto[] | undefined;
    /** Gets or sets The Unique identifier of the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto (1 theme, 2 sub theme, 3 cluster or 4 MeasureGroup) */
    assessmentEntityTypeId?: number;
    /** Gets or sets the external url. */
    externalUrl?: string | undefined;
    /** Gets or sets  WE.GPR.Connections.Models.Enums.AssessmentEntitySubTypeEnum */
    assessmentEntitySubTypeId?: number | undefined;
    /** Gets or sets the maximum points that can be assigned to the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like ForkOption */
    maximumPoints?: number | undefined;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto as WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum.Theme
This is used to link the to a specific theme. */
    dependentThemeKey?: string | undefined;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionExportDto;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentModelExportDto[] | undefined;

    constructor(data?: IAssessmentModelExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.text = _data["text"];
            if (Array.isArray(_data["manualSections"])) {
                this.manualSections = [] as any;
                for (let item of _data["manualSections"])
                    this.manualSections!.push(AssessmentEntityManualSectionDto.fromJS(item));
            }
            this.assessmentEntityTypeId = _data["assessmentEntityTypeId"];
            this.externalUrl = _data["externalUrl"];
            this.assessmentEntitySubTypeId = _data["assessmentEntitySubTypeId"];
            this.maximumPoints = _data["maximumPoints"];
            this.dependentThemeKey = _data["dependentThemeKey"];
            this.assessmentEntityByContentVersion = _data["assessmentEntityByContentVersion"] ? AssessmentEntityByContentVersionExportDto.fromJS(_data["assessmentEntityByContentVersion"]) : undefined as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssessmentModelExportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentModelExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentModelExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["text"] = this.text;
        if (Array.isArray(this.manualSections)) {
            data["manualSections"] = [];
            for (let item of this.manualSections)
                data["manualSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["assessmentEntityTypeId"] = this.assessmentEntityTypeId;
        data["externalUrl"] = this.externalUrl;
        data["assessmentEntitySubTypeId"] = this.assessmentEntitySubTypeId;
        data["maximumPoints"] = this.maximumPoints;
        data["dependentThemeKey"] = this.dependentThemeKey;
        data["assessmentEntityByContentVersion"] = this.assessmentEntityByContentVersion ? this.assessmentEntityByContentVersion.toJSON() : undefined as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Export dto for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto details in given content version */
export interface IAssessmentModelExportDto {
    /** Unique key for this entity. */
    key?: string;
    /** Gets or sets the Name (theme, subtheme or cluster) or Description (MeasureGroup) */
    text?: string | undefined;
    /** A collection of manual HTML like the Help text from a MeasureGroup */
    manualSections?: AssessmentEntityManualSectionDto[] | undefined;
    /** Gets or sets The Unique identifier of the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto (1 theme, 2 sub theme, 3 cluster or 4 MeasureGroup) */
    assessmentEntityTypeId?: number;
    /** Gets or sets the external url. */
    externalUrl?: string | undefined;
    /** Gets or sets  WE.GPR.Connections.Models.Enums.AssessmentEntitySubTypeEnum */
    assessmentEntitySubTypeId?: number | undefined;
    /** Gets or sets the maximum points that can be assigned to the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like ForkOption */
    maximumPoints?: number | undefined;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto as WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum.Theme
This is used to link the to a specific theme. */
    dependentThemeKey?: string | undefined;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionExportDto;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentModelExportDto[] | undefined;
}

/** Dto to hold the tree structure assessment model matrix data for user inputs by assessment subject type */
export class AssessmentModelMatrixDto implements IAssessmentModelMatrixDto {
    /** Gets or sets the name of entity */
    name?: string | undefined;
    /** Gets or sets the type of assessment entity based on WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum */
    assessmentEntityTypeId?: number;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentModelMatrixDto[] | undefined;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;

    constructor(data?: IAssessmentModelMatrixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.assessmentEntityTypeId = _data["assessmentEntityTypeId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssessmentModelMatrixDto.fromJS(item));
            }
            this.assessmentEntityByContentVersion = _data["assessmentEntityByContentVersion"] ? AssessmentEntityByContentVersionDto.fromJS(_data["assessmentEntityByContentVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): AssessmentModelMatrixDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentModelMatrixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["assessmentEntityTypeId"] = this.assessmentEntityTypeId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["assessmentEntityByContentVersion"] = this.assessmentEntityByContentVersion ? this.assessmentEntityByContentVersion.toJSON() : undefined as any;
        return data;
    }
}

/** Dto to hold the tree structure assessment model matrix data for user inputs by assessment subject type */
export interface IAssessmentModelMatrixDto {
    /** Gets or sets the name of entity */
    name?: string | undefined;
    /** Gets or sets the type of assessment entity based on WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum */
    assessmentEntityTypeId?: number;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentModelMatrixDto[] | undefined;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
}

/** <br>Gets or sets the properties for either WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto <br>Used for displaying the Entity in the flat list on the right panel in the tree configurator UI */
export class AssessmentOrProjectModelEntityForFlatListDto implements IAssessmentOrProjectModelEntityForFlatListDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the type, whether the entity is a AssessmentEntity (1), an Element (2) or a Parameter (3) */
    modelTypeId?: number;
    /** Gets or sets the name of entity (Assessment: Text of entity, ProjectModel: Name of entity) */
    name?: string | undefined;
    /** Gets or sets id of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeDto */
    entityTypeId?: number;
    /** Gets or sets unique Id of an ParameterType */
    parameterTypeId?: number;
    /** Gets whether this entity can be safely deleted, is true if entity is not mapped with any content version. If true, it is also safe to change the type of the entity. */
    readonly canDelete?: boolean;
    /** Gets whether the entity is mapped with the current content version, can only function properly if the id of the current content version was passed to the Web API endpoint */
    isLinkedToCurrentContentVersion?: boolean;
    /** Gets whether the entity is mapped with content version not being the current one, can only function properly if the id of the current content version was passed to the Web API endpoint */
    isLinkedToOtherContentVersion?: boolean;
    /** Gets or sets whether the entity can be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets the icon path for both Element and Parameter */
    iconPath?: string | undefined;

    constructor(data?: IAssessmentOrProjectModelEntityForFlatListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.modelTypeId = _data["modelTypeId"];
            this.name = _data["name"];
            this.entityTypeId = _data["entityTypeId"];
            this.parameterTypeId = _data["parameterTypeId"];
            (this as any).canDelete = _data["canDelete"];
            this.isLinkedToCurrentContentVersion = _data["isLinkedToCurrentContentVersion"];
            this.isLinkedToOtherContentVersion = _data["isLinkedToOtherContentVersion"];
            this.isRoot = _data["isRoot"];
            this.iconPath = _data["iconPath"];
        }
    }

    static fromJS(data: any): AssessmentOrProjectModelEntityForFlatListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentOrProjectModelEntityForFlatListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["modelTypeId"] = this.modelTypeId;
        data["name"] = this.name;
        data["entityTypeId"] = this.entityTypeId;
        data["parameterTypeId"] = this.parameterTypeId;
        data["canDelete"] = this.canDelete;
        data["isLinkedToCurrentContentVersion"] = this.isLinkedToCurrentContentVersion;
        data["isLinkedToOtherContentVersion"] = this.isLinkedToOtherContentVersion;
        data["isRoot"] = this.isRoot;
        data["iconPath"] = this.iconPath;
        return data;
    }
}

/** <br>Gets or sets the properties for either WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto <br>Used for displaying the Entity in the flat list on the right panel in the tree configurator UI */
export interface IAssessmentOrProjectModelEntityForFlatListDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the type, whether the entity is a AssessmentEntity (1), an Element (2) or a Parameter (3) */
    modelTypeId?: number;
    /** Gets or sets the name of entity (Assessment: Text of entity, ProjectModel: Name of entity) */
    name?: string | undefined;
    /** Gets or sets id of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeDto */
    entityTypeId?: number;
    /** Gets or sets unique Id of an ParameterType */
    parameterTypeId?: number;
    /** Gets whether this entity can be safely deleted, is true if entity is not mapped with any content version. If true, it is also safe to change the type of the entity. */
    canDelete?: boolean;
    /** Gets whether the entity is mapped with the current content version, can only function properly if the id of the current content version was passed to the Web API endpoint */
    isLinkedToCurrentContentVersion?: boolean;
    /** Gets whether the entity is mapped with content version not being the current one, can only function properly if the id of the current content version was passed to the Web API endpoint */
    isLinkedToOtherContentVersion?: boolean;
    /** Gets or sets whether the entity can be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets the icon path for both Element and Parameter */
    iconPath?: string | undefined;
}

/** <br>Gets or sets the properties for either Assessment or Project model tree <br>An entity with its relations to be used in the left hand side tree in the UI */
export class AssessmentOrProjectModelEntityForTreeDto implements IAssessmentOrProjectModelEntityForTreeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the type, whether the entity is a AssessmentEntity (1), an Element (2) or a Parameter (3) */
    modelTypeId?: number;
    /** Gets or sets unique Id of an ParameterType */
    parameterTypeId?: number;
    /** Gets or sets the name of entity (Assessment: Text of entity, ProjectModel: Name of entity) */
    name?: string | undefined;
    /** Gets or sets a text field for Explanation like the Help text from a MeasureGroup or Description for Parameter */
    explanation?: string | undefined;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentOrProjectModelEntityForTreeDto[] | undefined;
    parent?: AssessmentOrProjectModelEntityForTreeDto;
    /** Gets or sets unique identifier of the related WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto, WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterByElementByContentVersionDto */
    entityByContentVersionId?: number;
    /** Gets or sets the order of entity in EntityByContentVersion //todo: is this not ContentVersion? */
    order?: number;
    /** Gets or sets the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeDtoEntity */
    entityTypeId?: number;
    /** Gets or sets unique identifier of the parent entity by content version */
    parentEntityByContentVersionId?: number | undefined;
    /** <br>Gets or sets whether entity needs to be added or update
<br>True to add new entity is element tree and a relation to the content version and to the parent needs to be added
<br>Used in the SaveTree Web API endpoint */
    isNew?: boolean;
    /** <br>Gets or sets whether parent of entity has been changed in tree
<br>True if parent of entity is changed
<br>Used in the SaveTree Web API endpoint */
    isParentChange?: boolean;
    /** <br>Gets or sets whether entity is deleted from the tree
<br>True if entity has to be removed from the tree and thus the relation to the content version and the parent needs to be removed
<br>Used in the SaveTree Web API endpoint */
    isDeleted?: boolean;
    /** Gets or sets whether the entity can be used at root level of the tree */
    readonly isRoot?: boolean;
    /** Gets or sets whether the entity can be  linked to tree */
    readonly canBeLinkedMultipleTimes?: boolean;
    /** Gets or sets number of the entity based on the order of the entity like 1, 1.1, 1.2, 1.1.1 (theme.subtheme.MeasureGroup) etc */
    number?: string | undefined;
    /** Gets or sets whether this entity should be considered when determining the order for the numbering, true if the item should not be used for numbering */
    readonly isNotForNumbering?: boolean;
    /** Gets or sets the parent  theme id for the entity. */
    parentThemeId?: number;
    /** Gets or sets the icon path fot both Element and Parameter */
    iconPath?: string | undefined;
    /** Gets or sets NlSfbCode for Element */
    nlSfbCode?: string | undefined;
    /** Gets or sets unique identifier of an InputType for Parameter */
    inputTypeId?: number;
    unit?: UnitDto;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto for Parameter */
    parameterOptions?: ParameterOptionDto[] | undefined;

    constructor(data?: IAssessmentOrProjectModelEntityForTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.modelTypeId = _data["modelTypeId"];
            this.parameterTypeId = _data["parameterTypeId"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssessmentOrProjectModelEntityForTreeDto.fromJS(item));
            }
            this.parent = _data["parent"] ? AssessmentOrProjectModelEntityForTreeDto.fromJS(_data["parent"]) : undefined as any;
            this.entityByContentVersionId = _data["entityByContentVersionId"];
            this.order = _data["order"];
            this.entityTypeId = _data["entityTypeId"];
            this.parentEntityByContentVersionId = _data["parentEntityByContentVersionId"];
            this.isNew = _data["isNew"];
            this.isParentChange = _data["isParentChange"];
            this.isDeleted = _data["isDeleted"];
            (this as any).isRoot = _data["isRoot"];
            (this as any).canBeLinkedMultipleTimes = _data["canBeLinkedMultipleTimes"];
            this.number = _data["number"];
            (this as any).isNotForNumbering = _data["isNotForNumbering"];
            this.parentThemeId = _data["parentThemeId"];
            this.iconPath = _data["iconPath"];
            this.nlSfbCode = _data["nlSfbCode"];
            this.inputTypeId = _data["inputTypeId"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : undefined as any;
            if (Array.isArray(_data["parameterOptions"])) {
                this.parameterOptions = [] as any;
                for (let item of _data["parameterOptions"])
                    this.parameterOptions!.push(ParameterOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssessmentOrProjectModelEntityForTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentOrProjectModelEntityForTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["modelTypeId"] = this.modelTypeId;
        data["parameterTypeId"] = this.parameterTypeId;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["entityByContentVersionId"] = this.entityByContentVersionId;
        data["order"] = this.order;
        data["entityTypeId"] = this.entityTypeId;
        data["parentEntityByContentVersionId"] = this.parentEntityByContentVersionId;
        data["isNew"] = this.isNew;
        data["isParentChange"] = this.isParentChange;
        data["isDeleted"] = this.isDeleted;
        data["isRoot"] = this.isRoot;
        data["canBeLinkedMultipleTimes"] = this.canBeLinkedMultipleTimes;
        data["number"] = this.number;
        data["isNotForNumbering"] = this.isNotForNumbering;
        data["parentThemeId"] = this.parentThemeId;
        data["iconPath"] = this.iconPath;
        data["nlSfbCode"] = this.nlSfbCode;
        data["inputTypeId"] = this.inputTypeId;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        if (Array.isArray(this.parameterOptions)) {
            data["parameterOptions"] = [];
            for (let item of this.parameterOptions)
                data["parameterOptions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the properties for either Assessment or Project model tree <br>An entity with its relations to be used in the left hand side tree in the UI */
export interface IAssessmentOrProjectModelEntityForTreeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the type, whether the entity is a AssessmentEntity (1), an Element (2) or a Parameter (3) */
    modelTypeId?: number;
    /** Gets or sets unique Id of an ParameterType */
    parameterTypeId?: number;
    /** Gets or sets the name of entity (Assessment: Text of entity, ProjectModel: Name of entity) */
    name?: string | undefined;
    /** Gets or sets a text field for Explanation like the Help text from a MeasureGroup or Description for Parameter */
    explanation?: string | undefined;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentOrProjectModelEntityForTreeDto[] | undefined;
    parent?: AssessmentOrProjectModelEntityForTreeDto;
    /** Gets or sets unique identifier of the related WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto, WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterByElementByContentVersionDto */
    entityByContentVersionId?: number;
    /** Gets or sets the order of entity in EntityByContentVersion //todo: is this not ContentVersion? */
    order?: number;
    /** Gets or sets the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeDtoEntity */
    entityTypeId?: number;
    /** Gets or sets unique identifier of the parent entity by content version */
    parentEntityByContentVersionId?: number | undefined;
    /** <br>Gets or sets whether entity needs to be added or update
<br>True to add new entity is element tree and a relation to the content version and to the parent needs to be added
<br>Used in the SaveTree Web API endpoint */
    isNew?: boolean;
    /** <br>Gets or sets whether parent of entity has been changed in tree
<br>True if parent of entity is changed
<br>Used in the SaveTree Web API endpoint */
    isParentChange?: boolean;
    /** <br>Gets or sets whether entity is deleted from the tree
<br>True if entity has to be removed from the tree and thus the relation to the content version and the parent needs to be removed
<br>Used in the SaveTree Web API endpoint */
    isDeleted?: boolean;
    /** Gets or sets whether the entity can be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets whether the entity can be  linked to tree */
    canBeLinkedMultipleTimes?: boolean;
    /** Gets or sets number of the entity based on the order of the entity like 1, 1.1, 1.2, 1.1.1 (theme.subtheme.MeasureGroup) etc */
    number?: string | undefined;
    /** Gets or sets whether this entity should be considered when determining the order for the numbering, true if the item should not be used for numbering */
    isNotForNumbering?: boolean;
    /** Gets or sets the parent  theme id for the entity. */
    parentThemeId?: number;
    /** Gets or sets the icon path fot both Element and Parameter */
    iconPath?: string | undefined;
    /** Gets or sets NlSfbCode for Element */
    nlSfbCode?: string | undefined;
    /** Gets or sets unique identifier of an InputType for Parameter */
    inputTypeId?: number;
    unit?: UnitDto;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto for Parameter */
    parameterOptions?: ParameterOptionDto[] | undefined;
}

/** Defines the tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto type with mapped WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto */
export class AssessmentOrProjectModelWithExpressionForTreeDto implements IAssessmentOrProjectModelWithExpressionForTreeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the name of entity (Assessment: Text of entity, ProjectModel: Name of entity) */
    name?: string | undefined;
    /** Gets or sets the type, whether the entity is a AssessmentEntity (1), an Element (2) or a Parameter (3) */
    modelTypeId?: number;
    /** Gets or sets the unique identifier of parent entity */
    parentEntityId?: number | undefined;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentOrProjectModelWithExpressionForTreeDto[] | undefined;
    /** Gets or sets the entity type id of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto type */
    entityTypeId?: number;
    /** Gets or sets the linked expression for assessment entity (eg: linked to MeasureGroup) */
    linkedExpression?: string | undefined;
    /** Gets or sets expression name */
    expressionName?: string | undefined;
    /** Determines whether entity can have expression or not. */
    readonly canHaveExpression?: boolean;

    constructor(data?: IAssessmentOrProjectModelWithExpressionForTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.modelTypeId = _data["modelTypeId"];
            this.parentEntityId = _data["parentEntityId"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AssessmentOrProjectModelWithExpressionForTreeDto.fromJS(item));
            }
            this.entityTypeId = _data["entityTypeId"];
            this.linkedExpression = _data["linkedExpression"];
            this.expressionName = _data["expressionName"];
            (this as any).canHaveExpression = _data["canHaveExpression"];
        }
    }

    static fromJS(data: any): AssessmentOrProjectModelWithExpressionForTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentOrProjectModelWithExpressionForTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["modelTypeId"] = this.modelTypeId;
        data["parentEntityId"] = this.parentEntityId;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        data["entityTypeId"] = this.entityTypeId;
        data["linkedExpression"] = this.linkedExpression;
        data["expressionName"] = this.expressionName;
        data["canHaveExpression"] = this.canHaveExpression;
        return data;
    }
}

/** Defines the tree of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto type with mapped WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto */
export interface IAssessmentOrProjectModelWithExpressionForTreeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the name of entity (Assessment: Text of entity, ProjectModel: Name of entity) */
    name?: string | undefined;
    /** Gets or sets the type, whether the entity is a AssessmentEntity (1), an Element (2) or a Parameter (3) */
    modelTypeId?: number;
    /** Gets or sets the unique identifier of parent entity */
    parentEntityId?: number | undefined;
    /** Gets or sets child entities to build up the tree with */
    children?: AssessmentOrProjectModelWithExpressionForTreeDto[] | undefined;
    /** Gets or sets the entity type id of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityTypeDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto type */
    entityTypeId?: number;
    /** Gets or sets the linked expression for assessment entity (eg: linked to MeasureGroup) */
    linkedExpression?: string | undefined;
    /** Gets or sets expression name */
    expressionName?: string | undefined;
    /** Determines whether entity can have expression or not. */
    canHaveExpression?: boolean;
}

/** Export dto for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionByAssessmentSubjectDto */
export class AssessmentSubjectExportDto implements IAssessmentSubjectExportDto {
    /** Gets or Sets the Weight */
    weight?: number | undefined;
    /** Gets or sets the assessment subject type Id based on WE.GPR.Connections.Models.Enums.BuildingUseFunctionEnum */
    assessmentSubjectTypeId?: number;

    constructor(data?: IAssessmentSubjectExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weight = _data["weight"];
            this.assessmentSubjectTypeId = _data["assessmentSubjectTypeId"];
        }
    }

    static fromJS(data: any): AssessmentSubjectExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssessmentSubjectExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["assessmentSubjectTypeId"] = this.assessmentSubjectTypeId;
        return data;
    }
}

/** Export dto for WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionByAssessmentSubjectDto */
export interface IAssessmentSubjectExportDto {
    /** Gets or Sets the Weight */
    weight?: number | undefined;
    /** Gets or sets the assessment subject type Id based on WE.GPR.Connections.Models.Enums.BuildingUseFunctionEnum */
    assessmentSubjectTypeId?: number;
}

/** Get or sets the Assessment model matrix for building */
export class BuildingAssessmentModelMatrixDto implements IBuildingAssessmentModelMatrixDto {
    /** Gets or sets the name of entity */
    name?: string | undefined;
    /** Gets or sets the unique identifier */
    key?: string;
    /** A collection of manual HTML like the Help text from a MeasureGroup */
    manualSections?: AssessmentEntityManualSectionDto[] | undefined;
    /** Gets or sets the external url. */
    externalUrl?: string | undefined;
    /** Gets or sets the type of assessment entity based on WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum */
    assessmentEntityTypeId?: number;
    /** Gets or sets number of the entity based on the order of the entity like 1, 1.1, 1.2, 1.1.1 (theme.subtheme.MeasureGroup) etc */
    number?: string | undefined;
    /** Gets or sets the order of entity in EntityByContentVersion */
    order?: number;
    /** Gets or sets the maximum points that can be assigned to the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like ForkOption */
    maximumPoints?: number | undefined;
    /** Gets or sets the name of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto as WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum.Theme
This is used to link the to a specific theme. */
    dependentThemeName?: string | undefined;
    /** Gets or sets the type of assessment entity based on WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum */
    assessmentEntitySubTypeId?: number | undefined;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for new building configuration */
    isNewBuilding?: boolean;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for existing building configuration */
    isExistingBuilding?: boolean;
    /** Gets or sets child entities to build up the tree with */
    children?: BuildingAssessmentModelMatrixDto[] | undefined;
    /** Gets or sets the user inputs for each WE.AMP.Models.DataTransferObjects.AssessmentModel.BuildingAssessmentSubjectDto */
    buildingAssessmentSubject?: BuildingAssessmentSubjectDto[] | undefined;

    constructor(data?: IBuildingAssessmentModelMatrixDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.key = _data["key"];
            if (Array.isArray(_data["manualSections"])) {
                this.manualSections = [] as any;
                for (let item of _data["manualSections"])
                    this.manualSections!.push(AssessmentEntityManualSectionDto.fromJS(item));
            }
            this.externalUrl = _data["externalUrl"];
            this.assessmentEntityTypeId = _data["assessmentEntityTypeId"];
            this.number = _data["number"];
            this.order = _data["order"];
            this.maximumPoints = _data["maximumPoints"];
            this.dependentThemeName = _data["dependentThemeName"];
            this.assessmentEntitySubTypeId = _data["assessmentEntitySubTypeId"];
            this.isNewBuilding = _data["isNewBuilding"];
            this.isExistingBuilding = _data["isExistingBuilding"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BuildingAssessmentModelMatrixDto.fromJS(item));
            }
            if (Array.isArray(_data["buildingAssessmentSubject"])) {
                this.buildingAssessmentSubject = [] as any;
                for (let item of _data["buildingAssessmentSubject"])
                    this.buildingAssessmentSubject!.push(BuildingAssessmentSubjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BuildingAssessmentModelMatrixDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingAssessmentModelMatrixDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["key"] = this.key;
        if (Array.isArray(this.manualSections)) {
            data["manualSections"] = [];
            for (let item of this.manualSections)
                data["manualSections"].push(item ? item.toJSON() : undefined as any);
        }
        data["externalUrl"] = this.externalUrl;
        data["assessmentEntityTypeId"] = this.assessmentEntityTypeId;
        data["number"] = this.number;
        data["order"] = this.order;
        data["maximumPoints"] = this.maximumPoints;
        data["dependentThemeName"] = this.dependentThemeName;
        data["assessmentEntitySubTypeId"] = this.assessmentEntitySubTypeId;
        data["isNewBuilding"] = this.isNewBuilding;
        data["isExistingBuilding"] = this.isExistingBuilding;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.buildingAssessmentSubject)) {
            data["buildingAssessmentSubject"] = [];
            for (let item of this.buildingAssessmentSubject)
                data["buildingAssessmentSubject"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Get or sets the Assessment model matrix for building */
export interface IBuildingAssessmentModelMatrixDto {
    /** Gets or sets the name of entity */
    name?: string | undefined;
    /** Gets or sets the unique identifier */
    key?: string;
    /** A collection of manual HTML like the Help text from a MeasureGroup */
    manualSections?: AssessmentEntityManualSectionDto[] | undefined;
    /** Gets or sets the external url. */
    externalUrl?: string | undefined;
    /** Gets or sets the type of assessment entity based on WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum */
    assessmentEntityTypeId?: number;
    /** Gets or sets number of the entity based on the order of the entity like 1, 1.1, 1.2, 1.1.1 (theme.subtheme.MeasureGroup) etc */
    number?: string | undefined;
    /** Gets or sets the order of entity in EntityByContentVersion */
    order?: number;
    /** Gets or sets the maximum points that can be assigned to the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto like ForkOption */
    maximumPoints?: number | undefined;
    /** Gets or sets the name of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto as WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum.Theme
This is used to link the to a specific theme. */
    dependentThemeName?: string | undefined;
    /** Gets or sets the type of assessment entity based on WE.GPR.Connections.Models.Enums.AssessmentEntityTypeEnum */
    assessmentEntitySubTypeId?: number | undefined;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for new building configuration */
    isNewBuilding?: boolean;
    /** Gets or sets the boolean flag for the WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto whether this entity should be used for existing building configuration */
    isExistingBuilding?: boolean;
    /** Gets or sets child entities to build up the tree with */
    children?: BuildingAssessmentModelMatrixDto[] | undefined;
    /** Gets or sets the user inputs for each WE.AMP.Models.DataTransferObjects.AssessmentModel.BuildingAssessmentSubjectDto */
    buildingAssessmentSubject?: BuildingAssessmentSubjectDto[] | undefined;
}

/** Building Assessment Subject Dto */
export class BuildingAssessmentSubjectDto implements IBuildingAssessmentSubjectDto {
    /** Gets or Sets the Weight */
    weight?: number | undefined;
    /** Gets or sets the assessment subject type Id based on WE.GPR.Connections.Models.Enums.BuildingUseFunctionEnum */
    assessmentSubjectTypeId?: number;

    constructor(data?: IBuildingAssessmentSubjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weight = _data["weight"];
            this.assessmentSubjectTypeId = _data["assessmentSubjectTypeId"];
        }
    }

    static fromJS(data: any): BuildingAssessmentSubjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new BuildingAssessmentSubjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weight"] = this.weight;
        data["assessmentSubjectTypeId"] = this.assessmentSubjectTypeId;
        return data;
    }
}

/** Building Assessment Subject Dto */
export interface IBuildingAssessmentSubjectDto {
    /** Gets or Sets the Weight */
    weight?: number | undefined;
    /** Gets or sets the assessment subject type Id based on WE.GPR.Connections.Models.Enums.BuildingUseFunctionEnum */
    assessmentSubjectTypeId?: number;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto, update existing ones or get data from the database in this structure */
export class CalculationCoreDto implements ICalculationCoreDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name!: string;
    /** Gets or sets description */
    description?: string | undefined;
    /** Gets or sets endpoint */
    endPoint?: string | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto */
    calculationCoreVersions?: CalculationCoreVersionDto[] | undefined;

    constructor(data?: ICalculationCoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.endPoint = _data["endPoint"];
            if (Array.isArray(_data["calculationCoreVersions"])) {
                this.calculationCoreVersions = [] as any;
                for (let item of _data["calculationCoreVersions"])
                    this.calculationCoreVersions!.push(CalculationCoreVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationCoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["endPoint"] = this.endPoint;
        if (Array.isArray(this.calculationCoreVersions)) {
            data["calculationCoreVersions"] = [];
            for (let item of this.calculationCoreVersions)
                data["calculationCoreVersions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreDto, update existing ones or get data from the database in this structure */
export interface ICalculationCoreDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name: string;
    /** Gets or sets description */
    description?: string | undefined;
    /** Gets or sets endpoint */
    endPoint?: string | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto */
    calculationCoreVersions?: CalculationCoreVersionDto[] | undefined;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto, update existing ones or get data from the database in this structure */
export class CalculationCoreExpressionDto implements ICalculationCoreExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name?: string | undefined;
    /** Gets or sets explanation */
    explanation?: string | undefined;
    /** Gets or sets the Actual value of calculation */
    value!: string;
    /** Gets or sets RequestDataMemberName */
    requestDataMemberName?: string | undefined;
    /** Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto.CalculationCoreVersion */
    calculationCoreVersionId!: number;
    calculationCoreVersion?: CalculationCoreVersionDto;

    constructor(data?: ICalculationCoreExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            this.value = _data["value"];
            this.requestDataMemberName = _data["requestDataMemberName"];
            this.calculationCoreVersionId = _data["calculationCoreVersionId"];
            this.calculationCoreVersion = _data["calculationCoreVersion"] ? CalculationCoreVersionDto.fromJS(_data["calculationCoreVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationCoreExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        data["value"] = this.value;
        data["requestDataMemberName"] = this.requestDataMemberName;
        data["calculationCoreVersionId"] = this.calculationCoreVersionId;
        data["calculationCoreVersion"] = this.calculationCoreVersion ? this.calculationCoreVersion.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto, update existing ones or get data from the database in this structure */
export interface ICalculationCoreExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name?: string | undefined;
    /** Gets or sets explanation */
    explanation?: string | undefined;
    /** Gets or sets the Actual value of calculation */
    value: string;
    /** Gets or sets RequestDataMemberName */
    requestDataMemberName?: string | undefined;
    /** Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto.CalculationCoreVersion */
    calculationCoreVersionId: number;
    calculationCoreVersion?: CalculationCoreVersionDto;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto, update existing ones or get data from the database in this structure */
export class CalculationCoreResultExpressionDto implements ICalculationCoreResultExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name?: string | undefined;
    /** Gets or sets explanation */
    explanation?: string | undefined;
    /** Gets or sets the Actual value of calculation */
    value!: string;
    /** Gets or sets ResponseDataMemberName */
    responseDataMemberName?: string | undefined;
    /** Unique Id of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto */
    calculationCoreVersionId?: number | undefined;
    calculationCoreVersion?: CalculationCoreVersionDto;

    constructor(data?: ICalculationCoreResultExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            this.value = _data["value"];
            this.responseDataMemberName = _data["responseDataMemberName"];
            this.calculationCoreVersionId = _data["calculationCoreVersionId"];
            this.calculationCoreVersion = _data["calculationCoreVersion"] ? CalculationCoreVersionDto.fromJS(_data["calculationCoreVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): CalculationCoreResultExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreResultExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        data["value"] = this.value;
        data["responseDataMemberName"] = this.responseDataMemberName;
        data["calculationCoreVersionId"] = this.calculationCoreVersionId;
        data["calculationCoreVersion"] = this.calculationCoreVersion ? this.calculationCoreVersion.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto, update existing ones or get data from the database in this structure */
export interface ICalculationCoreResultExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name?: string | undefined;
    /** Gets or sets explanation */
    explanation?: string | undefined;
    /** Gets or sets the Actual value of calculation */
    value: string;
    /** Gets or sets ResponseDataMemberName */
    responseDataMemberName?: string | undefined;
    /** Unique Id of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto */
    calculationCoreVersionId?: number | undefined;
    calculationCoreVersion?: CalculationCoreVersionDto;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto, update existing ones or get entities from the database in this structure */
export class CalculationCoreVersionDto implements ICalculationCoreVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Version Number */
    number!: number;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto.CalculationCore */
    calculationCoreId?: number;
    calculationCore?: CalculationCoreDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto */
    calculationCoreResultExpressions?: CalculationCoreResultExpressionDto[] | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto */
    calculationCoreExpressions?: CalculationCoreExpressionDto[] | undefined;

    constructor(data?: ICalculationCoreVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.number = _data["number"];
            this.calculationCoreId = _data["calculationCoreId"];
            this.calculationCore = _data["calculationCore"] ? CalculationCoreDto.fromJS(_data["calculationCore"]) : undefined as any;
            if (Array.isArray(_data["calculationCoreResultExpressions"])) {
                this.calculationCoreResultExpressions = [] as any;
                for (let item of _data["calculationCoreResultExpressions"])
                    this.calculationCoreResultExpressions!.push(CalculationCoreResultExpressionDto.fromJS(item));
            }
            if (Array.isArray(_data["calculationCoreExpressions"])) {
                this.calculationCoreExpressions = [] as any;
                for (let item of _data["calculationCoreExpressions"])
                    this.calculationCoreExpressions!.push(CalculationCoreExpressionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CalculationCoreVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalculationCoreVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["number"] = this.number;
        data["calculationCoreId"] = this.calculationCoreId;
        data["calculationCore"] = this.calculationCore ? this.calculationCore.toJSON() : undefined as any;
        if (Array.isArray(this.calculationCoreResultExpressions)) {
            data["calculationCoreResultExpressions"] = [];
            for (let item of this.calculationCoreResultExpressions)
                data["calculationCoreResultExpressions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.calculationCoreExpressions)) {
            data["calculationCoreExpressions"] = [];
            for (let item of this.calculationCoreExpressions)
                data["calculationCoreExpressions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto, update existing ones or get entities from the database in this structure */
export interface ICalculationCoreVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Version Number */
    number: number;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreVersionDto.CalculationCore */
    calculationCoreId?: number;
    calculationCore?: CalculationCoreDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreResultExpressionDto */
    calculationCoreResultExpressions?: CalculationCoreResultExpressionDto[] | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.CalculationModel.CalculationCoreExpressionDto */
    calculationCoreExpressions?: CalculationCoreExpressionDto[] | undefined;
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ContentVersionDto like WE.AMP.Models.DataTransferObjects.ContentVersionDto.Number, WE.AMP.Models.DataTransferObjects.ContentVersionDto.Description, WE.AMP.Models.DataTransferObjects.ContentVersionDto.Status for an WE.AMP.Models.DataTransferObjects.ContentVersionDto.Application <br>Can be used to create a new content version, update existing ones or get entities from the database in this structure */
export class ContentVersionDto implements IContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Version Number */
    number!: number;
    /** Gets or sets the Description */
    description?: string | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.ContentVersionDto.Application */
    applicationId?: number;
    application?: ApplicationDto;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.ContentVersionDto.Status of this entity */
    statusId?: number;
    status?: StatusDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto */
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersions?: AssessmentEntityByContentVersionDto[] | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto
A session determines whether an WE.AMP.Models.DataTransferObjects.UserDto can make changes to a tree */
    editSessions?: EditSessionDto[] | undefined;

    constructor(data?: IContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.applicationId = _data["applicationId"];
            this.application = _data["application"] ? ApplicationDto.fromJS(_data["application"]) : undefined as any;
            this.statusId = _data["statusId"];
            this.status = _data["status"] ? StatusDto.fromJS(_data["status"]) : undefined as any;
            if (Array.isArray(_data["elementsByContentVersions"])) {
                this.elementsByContentVersions = [] as any;
                for (let item of _data["elementsByContentVersions"])
                    this.elementsByContentVersions!.push(ElementByContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["assessmentEntityByContentVersions"])) {
                this.assessmentEntityByContentVersions = [] as any;
                for (let item of _data["assessmentEntityByContentVersions"])
                    this.assessmentEntityByContentVersions!.push(AssessmentEntityByContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["editSessions"])) {
                this.editSessions = [] as any;
                for (let item of _data["editSessions"])
                    this.editSessions!.push(EditSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["number"] = this.number;
        data["description"] = this.description;
        data["applicationId"] = this.applicationId;
        data["application"] = this.application ? this.application.toJSON() : undefined as any;
        data["statusId"] = this.statusId;
        data["status"] = this.status ? this.status.toJSON() : undefined as any;
        if (Array.isArray(this.elementsByContentVersions)) {
            data["elementsByContentVersions"] = [];
            for (let item of this.elementsByContentVersions)
                data["elementsByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.assessmentEntityByContentVersions)) {
            data["assessmentEntityByContentVersions"] = [];
            for (let item of this.assessmentEntityByContentVersions)
                data["assessmentEntityByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.editSessions)) {
            data["editSessions"] = [];
            for (let item of this.editSessions)
                data["editSessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ContentVersionDto like WE.AMP.Models.DataTransferObjects.ContentVersionDto.Number, WE.AMP.Models.DataTransferObjects.ContentVersionDto.Description, WE.AMP.Models.DataTransferObjects.ContentVersionDto.Status for an WE.AMP.Models.DataTransferObjects.ContentVersionDto.Application <br>Can be used to create a new content version, update existing ones or get entities from the database in this structure */
export interface IContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Version Number */
    number: number;
    /** Gets or sets the Description */
    description?: string | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.ContentVersionDto.Application */
    applicationId?: number;
    application?: ApplicationDto;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.ContentVersionDto.Status of this entity */
    statusId?: number;
    status?: StatusDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto */
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersions?: AssessmentEntityByContentVersionDto[] | undefined;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto
A session determines whether an WE.AMP.Models.DataTransferObjects.UserDto can make changes to a tree */
    editSessions?: EditSessionDto[] | undefined;
}

export class ContentVersionExportDto implements IContentVersionExportDto {
    /** Gets or sets the migration id of database from which data is exported */
    migrationId?: string | undefined;
    /** Gets or sets the Version Number */
    number?: number;
    /** Gets or sets the Description */
    description?: string | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.ApplicationDto */
    applicationId?: number;
    /** Gets or sets the name for the WE.AMP.Models.DataTransferObjects.ApplicationDto */
    applicationName?: string | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.Enums.StatusEnum of this entity */
    statusId?: number;
    /** Gets or sets the WE.AMP.Models.DataTransferObjects.StatusDto */
    status?: string | undefined;
    /** Gets or sets the tree structure of the assessment model with matrix data for the given content version */
    assessmentModelExportList?: AssessmentModelExportDto[] | undefined;

    constructor(data?: IContentVersionExportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.migrationId = _data["migrationId"];
            this.number = _data["number"];
            this.description = _data["description"];
            this.applicationId = _data["applicationId"];
            this.applicationName = _data["applicationName"];
            this.statusId = _data["statusId"];
            this.status = _data["status"];
            if (Array.isArray(_data["assessmentModelExportList"])) {
                this.assessmentModelExportList = [] as any;
                for (let item of _data["assessmentModelExportList"])
                    this.assessmentModelExportList!.push(AssessmentModelExportDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContentVersionExportDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContentVersionExportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["migrationId"] = this.migrationId;
        data["number"] = this.number;
        data["description"] = this.description;
        data["applicationId"] = this.applicationId;
        data["applicationName"] = this.applicationName;
        data["statusId"] = this.statusId;
        data["status"] = this.status;
        if (Array.isArray(this.assessmentModelExportList)) {
            data["assessmentModelExportList"] = [];
            for (let item of this.assessmentModelExportList)
                data["assessmentModelExportList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContentVersionExportDto {
    /** Gets or sets the migration id of database from which data is exported */
    migrationId?: string | undefined;
    /** Gets or sets the Version Number */
    number?: number;
    /** Gets or sets the Description */
    description?: string | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.DataTransferObjects.ApplicationDto */
    applicationId?: number;
    /** Gets or sets the name for the WE.AMP.Models.DataTransferObjects.ApplicationDto */
    applicationName?: string | undefined;
    /** Gets or sets the unique identifier for the WE.AMP.Models.Enums.StatusEnum of this entity */
    statusId?: number;
    /** Gets or sets the WE.AMP.Models.DataTransferObjects.StatusDto */
    status?: string | undefined;
    /** Gets or sets the tree structure of the assessment model with matrix data for the given content version */
    assessmentModelExportList?: AssessmentModelExportDto[] | undefined;
}

/** <br>Gets or sets the data of an DataContract WE.AMP.Models.DataTransferObjects.DataInfoModel.DataContractDto */
export class DataContractDto implements IDataContractDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name!: string;
    /** Gets or sets BaseContract */
    baseContractId!: number;
    baseContract?: DataContractDto;
    /** Unique Id of WE.AMP.Models.DataTransferObjects.DataInfoModel.DataContractDto.CalculationCoreVersion */
    calculationCoreVersionId!: number;
    calculationCoreVersion?: CalculationCoreVersionDto;
    /** Gets or sets the collection of WE.AMP.Models.Entities.DataInfoModel.DataMember */
    dataMembers?: DataMemberDto[] | undefined;

    constructor(data?: IDataContractDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.baseContractId = _data["baseContractId"];
            this.baseContract = _data["baseContract"] ? DataContractDto.fromJS(_data["baseContract"]) : undefined as any;
            this.calculationCoreVersionId = _data["calculationCoreVersionId"];
            this.calculationCoreVersion = _data["calculationCoreVersion"] ? CalculationCoreVersionDto.fromJS(_data["calculationCoreVersion"]) : undefined as any;
            if (Array.isArray(_data["dataMembers"])) {
                this.dataMembers = [] as any;
                for (let item of _data["dataMembers"])
                    this.dataMembers!.push(DataMemberDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataContractDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataContractDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["baseContractId"] = this.baseContractId;
        data["baseContract"] = this.baseContract ? this.baseContract.toJSON() : undefined as any;
        data["calculationCoreVersionId"] = this.calculationCoreVersionId;
        data["calculationCoreVersion"] = this.calculationCoreVersion ? this.calculationCoreVersion.toJSON() : undefined as any;
        if (Array.isArray(this.dataMembers)) {
            data["dataMembers"] = [];
            for (let item of this.dataMembers)
                data["dataMembers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the data of an DataContract WE.AMP.Models.DataTransferObjects.DataInfoModel.DataContractDto */
export interface IDataContractDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets name */
    name: string;
    /** Gets or sets BaseContract */
    baseContractId: number;
    baseContract?: DataContractDto;
    /** Unique Id of WE.AMP.Models.DataTransferObjects.DataInfoModel.DataContractDto.CalculationCoreVersion */
    calculationCoreVersionId: number;
    calculationCoreVersion?: CalculationCoreVersionDto;
    /** Gets or sets the collection of WE.AMP.Models.Entities.DataInfoModel.DataMember */
    dataMembers?: DataMemberDto[] | undefined;
}

/** <br>Gets or sets the data of an DataMember WE.AMP.Models.DataTransferObjects.DataInfoModel.DataMemberDto */
export class DataMemberDto implements IDataMemberDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key!: string;
    /** Gets or sets name */
    name!: string;
    /** Gets or sets the description */
    description?: string | undefined;
    /** Gets or Sets IsEnumerable */
    isEnumerable?: boolean;
    /** Gets or sets the DataType */
    dataType?: string | undefined;
    /** Gets or sets DataContract */
    dataContractId!: number;
    dataContract?: DataContractDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
    parameters?: ParameterDto[] | undefined;

    constructor(data?: IDataMemberDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isEnumerable = _data["isEnumerable"];
            this.dataType = _data["dataType"];
            this.dataContractId = _data["dataContractId"];
            this.dataContract = _data["dataContract"] ? DataContractDto.fromJS(_data["dataContract"]) : undefined as any;
            if (Array.isArray(_data["parameters"])) {
                this.parameters = [] as any;
                for (let item of _data["parameters"])
                    this.parameters!.push(ParameterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataMemberDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataMemberDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isEnumerable"] = this.isEnumerable;
        data["dataType"] = this.dataType;
        data["dataContractId"] = this.dataContractId;
        data["dataContract"] = this.dataContract ? this.dataContract.toJSON() : undefined as any;
        if (Array.isArray(this.parameters)) {
            data["parameters"] = [];
            for (let item of this.parameters)
                data["parameters"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the data of an DataMember WE.AMP.Models.DataTransferObjects.DataInfoModel.DataMemberDto */
export interface IDataMemberDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key: string;
    /** Gets or sets name */
    name: string;
    /** Gets or sets the description */
    description?: string | undefined;
    /** Gets or Sets IsEnumerable */
    isEnumerable?: boolean;
    /** Gets or sets the DataType */
    dataType?: string | undefined;
    /** Gets or sets DataContract */
    dataContractId: number;
    dataContract?: DataContractDto;
    /** Gets or sets the collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
    parameters?: ParameterDto[] | undefined;
}

/** This is Dto define configuration for the dependency between WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDtos */
export class DependentDto implements IDependentDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key for multi language. */
    key!: string;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOverrideDto */
    parameterOverrideId!: number;
    parameterOverride?: ParameterOverrideDto;
    /** Gets or sets unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto */
    parameterOptionId?: number | undefined;
    parameterOption?: ParameterOptionDto;
    /** Gets or sets the default value of dependent WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto
If the type of input is selectbox then consider this as unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto */
    defaultValue?: string | undefined;
    /** Gets or set the unique identifier of WE.AMP.Models.Enums.ParameterInputTypeEnum (so Input as input,TextArea, SelectList or Checkbox) */
    inputTypeId!: number;
    inputType?: InputTypeDto;
    /** Gets or sets the unique identifier of WE.GPR.Connections.Models.Enums.DataTypeEnum */
    dataTypeId!: number;
    /** Gets or sets the unique identifier of dependent WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
    dependentParameterId!: number;
    dependentParameter?: ParameterDto;

    constructor(data?: IDependentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.parameterOverrideId = _data["parameterOverrideId"];
            this.parameterOverride = _data["parameterOverride"] ? ParameterOverrideDto.fromJS(_data["parameterOverride"]) : undefined as any;
            this.parameterOptionId = _data["parameterOptionId"];
            this.parameterOption = _data["parameterOption"] ? ParameterOptionDto.fromJS(_data["parameterOption"]) : undefined as any;
            this.defaultValue = _data["defaultValue"];
            this.inputTypeId = _data["inputTypeId"];
            this.inputType = _data["inputType"] ? InputTypeDto.fromJS(_data["inputType"]) : undefined as any;
            this.dataTypeId = _data["dataTypeId"];
            this.dependentParameterId = _data["dependentParameterId"];
            this.dependentParameter = _data["dependentParameter"] ? ParameterDto.fromJS(_data["dependentParameter"]) : undefined as any;
        }
    }

    static fromJS(data: any): DependentDto {
        data = typeof data === 'object' ? data : {};
        let result = new DependentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["parameterOverrideId"] = this.parameterOverrideId;
        data["parameterOverride"] = this.parameterOverride ? this.parameterOverride.toJSON() : undefined as any;
        data["parameterOptionId"] = this.parameterOptionId;
        data["parameterOption"] = this.parameterOption ? this.parameterOption.toJSON() : undefined as any;
        data["defaultValue"] = this.defaultValue;
        data["inputTypeId"] = this.inputTypeId;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["dataTypeId"] = this.dataTypeId;
        data["dependentParameterId"] = this.dependentParameterId;
        data["dependentParameter"] = this.dependentParameter ? this.dependentParameter.toJSON() : undefined as any;
        return data;
    }
}

/** This is Dto define configuration for the dependency between WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDtos */
export interface IDependentDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key for multi language. */
    key: string;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOverrideDto */
    parameterOverrideId: number;
    parameterOverride?: ParameterOverrideDto;
    /** Gets or sets unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto */
    parameterOptionId?: number | undefined;
    parameterOption?: ParameterOptionDto;
    /** Gets or sets the default value of dependent WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto
If the type of input is selectbox then consider this as unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOptionDto */
    defaultValue?: string | undefined;
    /** Gets or set the unique identifier of WE.AMP.Models.Enums.ParameterInputTypeEnum (so Input as input,TextArea, SelectList or Checkbox) */
    inputTypeId: number;
    inputType?: InputTypeDto;
    /** Gets or sets the unique identifier of WE.GPR.Connections.Models.Enums.DataTypeEnum */
    dataTypeId: number;
    /** Gets or sets the unique identifier of dependent WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
    dependentParameterId: number;
    dependentParameter?: ParameterDto;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto for a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.User and WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.EditSessionType in a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.ContentVersion <br>Can be used to create a new session, update existing ones or get entities from the database in this structure <br>A session determines whether an WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.User can make changes to a tree */
export class EditSessionDto implements IEditSessionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets unique identifier for related WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets unique identifier for related WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.User */
    userId!: number;
    user?: UserDto;
    /** Gets or sets unique identifier for the WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto */
    editSessionTypeId!: number;
    editSessionType?: EditSessionTypeDto;
    /** Gets or sets The date and time the session was last used for writing to the database */
    sessionDate?: Date;

    constructor(data?: IEditSessionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            this.userId = _data["userId"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            this.editSessionTypeId = _data["editSessionTypeId"];
            this.editSessionType = _data["editSessionType"] ? EditSessionTypeDto.fromJS(_data["editSessionType"]) : undefined as any;
            this.sessionDate = _data["sessionDate"] ? new Date(_data["sessionDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): EditSessionDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSessionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        data["editSessionTypeId"] = this.editSessionTypeId;
        data["editSessionType"] = this.editSessionType ? this.editSessionType.toJSON() : undefined as any;
        data["sessionDate"] = this.sessionDate ? this.sessionDate.toISOString() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto for a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.User and WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.EditSessionType in a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.ContentVersion <br>Can be used to create a new session, update existing ones or get entities from the database in this structure <br>A session determines whether an WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.User can make changes to a tree */
export interface IEditSessionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets unique identifier for related WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets unique identifier for related WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto.User */
    userId: number;
    user?: UserDto;
    /** Gets or sets unique identifier for the WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto */
    editSessionTypeId: number;
    editSessionType?: EditSessionTypeDto;
    /** Gets or sets The date and time the session was last used for writing to the database */
    sessionDate?: Date;
}

/** <br>Gets or sets the Type of model (Assessment, Project, Parameter) when getting or setting a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto.EditSessions <br>Used for storing the model value for which the user in a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto is editing */
export class EditSessionTypeDto implements IEditSessionTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Value of editsession (Assessment, Project, Parameter) */
    value!: string;
    /** Gets or sets the sessions that use this type */
    editSessions?: EditSessionDto[] | undefined;

    constructor(data?: IEditSessionTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            if (Array.isArray(_data["editSessions"])) {
                this.editSessions = [] as any;
                for (let item of _data["editSessions"])
                    this.editSessions!.push(EditSessionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditSessionTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditSessionTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        if (Array.isArray(this.editSessions)) {
            data["editSessions"] = [];
            for (let item of this.editSessions)
                data["editSessions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the Type of model (Assessment, Project, Parameter) when getting or setting a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionTypeDto.EditSessions <br>Used for storing the model value for which the user in a WE.AMP.Models.DataTransferObjects.SessionModel.EditSessionDto is editing */
export interface IEditSessionTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the Value of editsession (Assessment, Project, Parameter) */
    value: string;
    /** Gets or sets the sessions that use this type */
    editSessions?: EditSessionDto[] | undefined;
}

/** <br>Gets or sets a relationship between WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and a WE.AMP.Models.DataTransferObjects.ContentVersionDto and also stores the order in which the entity should be gotten or set <br>Used to place an WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto in the correct order in the Project model tree */
export class ElementByContentVersionDto implements IElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the order */
    order?: number;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.Element */
    elementId!: number;
    element?: ElementDto;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.ContentVersion */
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets The reference to the children of this element, to get a child call WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Child after calling WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.ReferencedChildren */
    referencedChildren?: ElementByContentVersionSelfReferenceDto[] | undefined;
    /** Gets or sets The reference to the parents, to get a parent call WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Parent after calling WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.ReferencedParents */
    referencedParents?: ElementByContentVersionSelfReferenceDto[] | undefined;
    /** ToDo: will be refactored out with new relation between parameter and element */
    parameterByElementByContentVersions?: ParameterByElementByContentVersionDto[] | undefined;

    constructor(data?: IElementByContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.order = _data["order"];
            this.elementId = _data["elementId"];
            this.element = _data["element"] ? ElementDto.fromJS(_data["element"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            if (Array.isArray(_data["referencedChildren"])) {
                this.referencedChildren = [] as any;
                for (let item of _data["referencedChildren"])
                    this.referencedChildren!.push(ElementByContentVersionSelfReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["referencedParents"])) {
                this.referencedParents = [] as any;
                for (let item of _data["referencedParents"])
                    this.referencedParents!.push(ElementByContentVersionSelfReferenceDto.fromJS(item));
            }
            if (Array.isArray(_data["parameterByElementByContentVersions"])) {
                this.parameterByElementByContentVersions = [] as any;
                for (let item of _data["parameterByElementByContentVersions"])
                    this.parameterByElementByContentVersions!.push(ParameterByElementByContentVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementByContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementByContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["order"] = this.order;
        data["elementId"] = this.elementId;
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        if (Array.isArray(this.referencedChildren)) {
            data["referencedChildren"] = [];
            for (let item of this.referencedChildren)
                data["referencedChildren"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.referencedParents)) {
            data["referencedParents"] = [];
            for (let item of this.referencedParents)
                data["referencedParents"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parameterByElementByContentVersions)) {
            data["parameterByElementByContentVersions"] = [];
            for (let item of this.parameterByElementByContentVersions)
                data["parameterByElementByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets a relationship between WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and a WE.AMP.Models.DataTransferObjects.ContentVersionDto and also stores the order in which the entity should be gotten or set <br>Used to place an WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto in the correct order in the Project model tree */
export interface IElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the order */
    order?: number;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.Element */
    elementId: number;
    element?: ElementDto;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.ContentVersion */
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets The reference to the children of this element, to get a child call WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Child after calling WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.ReferencedChildren */
    referencedChildren?: ElementByContentVersionSelfReferenceDto[] | undefined;
    /** Gets or sets The reference to the parents, to get a parent call WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Parent after calling WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto.ReferencedParents */
    referencedParents?: ElementByContentVersionSelfReferenceDto[] | undefined;
    /** ToDo: will be refactored out with new relation between parameter and element */
    parameterByElementByContentVersions?: ParameterByElementByContentVersionDto[] | undefined;
}

/** <br>Gets or sets the many to many relationship between Parent and Child of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto <br>Used to store the project model tree */
export class ElementByContentVersionSelfReferenceDto implements IElementByContentVersionSelfReferenceDto {
    /** Gets or sets the Unique identifier WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Parent */
    parentId!: number;
    parent?: ElementByContentVersionDto;
    /** Gets or sets the Unique identifier WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Child */
    childId!: number;
    child?: ElementByContentVersionDto;

    constructor(data?: IElementByContentVersionSelfReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"];
            this.parent = _data["parent"] ? ElementByContentVersionDto.fromJS(_data["parent"]) : undefined as any;
            this.childId = _data["childId"];
            this.child = _data["child"] ? ElementByContentVersionDto.fromJS(_data["child"]) : undefined as any;
        }
    }

    static fromJS(data: any): ElementByContentVersionSelfReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementByContentVersionSelfReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["childId"] = this.childId;
        data["child"] = this.child ? this.child.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the many to many relationship between Parent and Child of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto <br>Used to store the project model tree */
export interface IElementByContentVersionSelfReferenceDto {
    /** Gets or sets the Unique identifier WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Parent */
    parentId: number;
    parent?: ElementByContentVersionDto;
    /** Gets or sets the Unique identifier WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionSelfReferenceDto.Child */
    childId: number;
    child?: ElementByContentVersionDto;
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto, its WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto.ElementType (ex: windows,doors), etc <br>Can be used to create a new property, update existing ones or get entities from the database in this structure */
export class ElementDto implements IElementDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key for multi language */
    key?: string | undefined;
    /** Gets or sets unique identifier of ElementType */
    elementTypeId!: number;
    elementType?: ElementTypeDto;
    /** Gets or sets a collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto.ElementOverrides */
    elementOverrides?: ElementOverrideDto[] | undefined;
    /** Gets or sets a collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto.ElementsByContentVersions in this entity is connected to a WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    /** Gets or sets the relation between WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto, WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto, WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;

    constructor(data?: IElementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.elementTypeId = _data["elementTypeId"];
            this.elementType = _data["elementType"] ? ElementTypeDto.fromJS(_data["elementType"]) : undefined as any;
            if (Array.isArray(_data["elementOverrides"])) {
                this.elementOverrides = [] as any;
                for (let item of _data["elementOverrides"])
                    this.elementOverrides!.push(ElementOverrideDto.fromJS(item));
            }
            if (Array.isArray(_data["elementsByContentVersions"])) {
                this.elementsByContentVersions = [] as any;
                for (let item of _data["elementsByContentVersions"])
                    this.elementsByContentVersions!.push(ElementByContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["expressionByParameterElementAndContentVersions"])) {
                this.expressionByParameterElementAndContentVersions = [] as any;
                for (let item of _data["expressionByParameterElementAndContentVersions"])
                    this.expressionByParameterElementAndContentVersions!.push(ExpressionByParameterElementAndContentVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["elementTypeId"] = this.elementTypeId;
        data["elementType"] = this.elementType ? this.elementType.toJSON() : undefined as any;
        if (Array.isArray(this.elementOverrides)) {
            data["elementOverrides"] = [];
            for (let item of this.elementOverrides)
                data["elementOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.elementsByContentVersions)) {
            data["elementsByContentVersions"] = [];
            for (let item of this.elementsByContentVersions)
                data["elementsByContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.expressionByParameterElementAndContentVersions)) {
            data["expressionByParameterElementAndContentVersions"] = [];
            for (let item of this.expressionByParameterElementAndContentVersions)
                data["expressionByParameterElementAndContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto, its WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto.ElementType (ex: windows,doors), etc <br>Can be used to create a new property, update existing ones or get entities from the database in this structure */
export interface IElementDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key for multi language */
    key?: string | undefined;
    /** Gets or sets unique identifier of ElementType */
    elementTypeId: number;
    elementType?: ElementTypeDto;
    /** Gets or sets a collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto.ElementOverrides */
    elementOverrides?: ElementOverrideDto[] | undefined;
    /** Gets or sets a collection of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto.ElementsByContentVersions in this entity is connected to a WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    elementsByContentVersions?: ElementByContentVersionDto[] | undefined;
    /** Gets or sets the relation between WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto, WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto, WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;
}

/** Dto for WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto */
export class ElementOverrideDto implements IElementOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the name of the element */
    name!: string;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto.Element */
    elementId?: number;
    element?: ElementDto;
    /** Gets or set the unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto.ContentVersion */
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets the explanation */
    explanation?: string | undefined;
    /** Gets or sets the relative icon path, used in the UI */
    iconPath?: string | undefined;
    /** Gets or sets NlSfbCode as is described on http://nl-sfb.bk.tudelft.nl/ */
    nlSfbCode?: string | undefined;
    /** Get or set whether it is required for the user to fill out the N:WE.AMP.Models.DataTransferObjects.ProjectModel.Parameters for this WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto.Element */
    isRequired?: boolean;

    constructor(data?: IElementOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.elementId = _data["elementId"];
            this.element = _data["element"] ? ElementDto.fromJS(_data["element"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            this.explanation = _data["explanation"];
            this.iconPath = _data["iconPath"];
            this.nlSfbCode = _data["nlSfbCode"];
            this.isRequired = _data["isRequired"];
        }
    }

    static fromJS(data: any): ElementOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["elementId"] = this.elementId;
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        data["explanation"] = this.explanation;
        data["iconPath"] = this.iconPath;
        data["nlSfbCode"] = this.nlSfbCode;
        data["isRequired"] = this.isRequired;
        return data;
    }
}

/** Dto for WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto */
export interface IElementOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the name of the element */
    name: string;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto.Element */
    elementId?: number;
    element?: ElementDto;
    /** Gets or set the unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto.ContentVersion */
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets the explanation */
    explanation?: string | undefined;
    /** Gets or sets the relative icon path, used in the UI */
    iconPath?: string | undefined;
    /** Gets or sets NlSfbCode as is described on http://nl-sfb.bk.tudelft.nl/ */
    nlSfbCode?: string | undefined;
    /** Get or set whether it is required for the user to fill out the N:WE.AMP.Models.DataTransferObjects.ProjectModel.Parameters for this WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementOverrideDto.Element */
    isRequired?: boolean;
}

/** <br>Get or sets the type of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto <br>Used to describe The type of the Element (so Main, Composite or Single) */
export class ElementTypeDto implements IElementTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets The Value of type */
    value!: string;
    /** Gets or sets whether this type can be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets the parent self references for thie WE.AMP.Models.Entities.ProjectModel.ElementType */
    referencedParents?: ElementTypeSelfReferenceDto[] | undefined;

    constructor(data?: IElementTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            this.isRoot = _data["isRoot"];
            if (Array.isArray(_data["referencedParents"])) {
                this.referencedParents = [] as any;
                for (let item of _data["referencedParents"])
                    this.referencedParents!.push(ElementTypeSelfReferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ElementTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        data["isRoot"] = this.isRoot;
        if (Array.isArray(this.referencedParents)) {
            data["referencedParents"] = [];
            for (let item of this.referencedParents)
                data["referencedParents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Get or sets the type of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto <br>Used to describe The type of the Element (so Main, Composite or Single) */
export interface IElementTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets The Value of type */
    value: string;
    /** Gets or sets whether this type can be used at root level of the tree */
    isRoot?: boolean;
    /** Gets or sets the parent self references for thie WE.AMP.Models.Entities.ProjectModel.ElementType */
    referencedParents?: ElementTypeSelfReferenceDto[] | undefined;
}

/** Describes the many to many parent child relation between WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeDto entities which can be used for validation purposes of a valid parent child relationship in the projectmodel tree */
export class ElementTypeSelfReferenceDto implements IElementTypeSelfReferenceDto {
    /** Gets or sets the unique identifier of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ParentElementType of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ChildElementType */
    parentElementId!: number;
    parentElementType?: ElementTypeDto;
    /** Gets or sets the unique identifier of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ChildElementType of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ParentElementType */
    childElementTypeId!: number;
    childElementType?: ElementTypeDto;

    constructor(data?: IElementTypeSelfReferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentElementId = _data["parentElementId"];
            this.parentElementType = _data["parentElementType"] ? ElementTypeDto.fromJS(_data["parentElementType"]) : undefined as any;
            this.childElementTypeId = _data["childElementTypeId"];
            this.childElementType = _data["childElementType"] ? ElementTypeDto.fromJS(_data["childElementType"]) : undefined as any;
        }
    }

    static fromJS(data: any): ElementTypeSelfReferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ElementTypeSelfReferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentElementId"] = this.parentElementId;
        data["parentElementType"] = this.parentElementType ? this.parentElementType.toJSON() : undefined as any;
        data["childElementTypeId"] = this.childElementTypeId;
        data["childElementType"] = this.childElementType ? this.childElementType.toJSON() : undefined as any;
        return data;
    }
}

/** Describes the many to many parent child relation between WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeDto entities which can be used for validation purposes of a valid parent child relationship in the projectmodel tree */
export interface IElementTypeSelfReferenceDto {
    /** Gets or sets the unique identifier of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ParentElementType of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ChildElementType */
    parentElementId: number;
    parentElementType?: ElementTypeDto;
    /** Gets or sets the unique identifier of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ChildElementType of the WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementTypeSelfReferenceDto.ParentElementType */
    childElementTypeId: number;
    childElementType?: ElementTypeDto;
}

/** <br>Gets or sets a Many to many relationship between the WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto on the one hand and WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto on the other, for a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to link WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Parameter to the WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.ParameterToAssessmentExpressions they are used in. The WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Element property is needed because one WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Parameter can be used multiple times in a WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.ContentVersion but only in different WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Element */
export class ExpressionByParameterElementAndContentVersionDto implements IExpressionByParameterElementAndContentVersionDto {
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto */
    parameterToAssessmentExpressionId!: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Parameter */
    parameterId!: number;
    parameter?: ParameterDto;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto */
    elementId!: number;
    element?: ElementDto;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId!: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionId!: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    /** Gets or sets the variable used in expression */
    expressionVariable!: string;

    constructor(data?: IExpressionByParameterElementAndContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parameterToAssessmentExpressionId = _data["parameterToAssessmentExpressionId"];
            this.parameterToAssessmentExpression = _data["parameterToAssessmentExpression"] ? ParameterToAssessmentExpressionDto.fromJS(_data["parameterToAssessmentExpression"]) : undefined as any;
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.elementId = _data["elementId"];
            this.element = _data["element"] ? ElementDto.fromJS(_data["element"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.contentVersion = _data["contentVersion"] ? ContentVersionDto.fromJS(_data["contentVersion"]) : undefined as any;
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.assessmentEntityByContentVersion = _data["assessmentEntityByContentVersion"] ? AssessmentEntityByContentVersionDto.fromJS(_data["assessmentEntityByContentVersion"]) : undefined as any;
            this.expressionVariable = _data["expressionVariable"];
        }
    }

    static fromJS(data: any): ExpressionByParameterElementAndContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpressionByParameterElementAndContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parameterToAssessmentExpressionId"] = this.parameterToAssessmentExpressionId;
        data["parameterToAssessmentExpression"] = this.parameterToAssessmentExpression ? this.parameterToAssessmentExpression.toJSON() : undefined as any;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["elementId"] = this.elementId;
        data["element"] = this.element ? this.element.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["contentVersion"] = this.contentVersion ? this.contentVersion.toJSON() : undefined as any;
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["assessmentEntityByContentVersion"] = this.assessmentEntityByContentVersion ? this.assessmentEntityByContentVersion.toJSON() : undefined as any;
        data["expressionVariable"] = this.expressionVariable;
        return data;
    }
}

/** <br>Gets or sets a Many to many relationship between the WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto on the one hand and WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto on the other, for a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to link WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Parameter to the WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.ParameterToAssessmentExpressions they are used in. The WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Element property is needed because one WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Parameter can be used multiple times in a WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.ContentVersion but only in different WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Element */
export interface IExpressionByParameterElementAndContentVersionDto {
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto */
    parameterToAssessmentExpressionId: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ExpressionByParameterElementAndContentVersionDto.Parameter */
    parameterId: number;
    parameter?: ParameterDto;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto */
    elementId: number;
    element?: ElementDto;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId: number;
    contentVersion?: ContentVersionDto;
    /** Gets or sets the unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionId: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    /** Gets or sets the variable used in expression */
    expressionVariable: string;
}

/** Model dto for building Assessment Model tree with expressions */
export class ExpressionModelTreeDto implements IExpressionModelTreeDto {
    /** Gets or sets the List of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto with mapped expression. */
    entitiesForTreeDto?: AssessmentOrProjectModelWithExpressionForTreeDto[] | undefined;

    constructor(data?: IExpressionModelTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["entitiesForTreeDto"])) {
                this.entitiesForTreeDto = [] as any;
                for (let item of _data["entitiesForTreeDto"])
                    this.entitiesForTreeDto!.push(AssessmentOrProjectModelWithExpressionForTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExpressionModelTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExpressionModelTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.entitiesForTreeDto)) {
            data["entitiesForTreeDto"] = [];
            for (let item of this.entitiesForTreeDto)
                data["entitiesForTreeDto"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Model dto for building Assessment Model tree with expressions */
export interface IExpressionModelTreeDto {
    /** Gets or sets the List of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto or WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto with mapped expression. */
    entitiesForTreeDto?: AssessmentOrProjectModelWithExpressionForTreeDto[] | undefined;
}

/** Can be used to add addons to the formly model https://ngx-formly.github.io/ngx-formly/examples/bootstrap-specific/input-add-ons */
export class FormlyAddonDto implements IFormlyAddonDto {
    /** A text addon */
    text?: string | undefined;
    /** An addon in the form of a class to display for example an Font Awesome icon */
    class?: string | undefined;

    constructor(data?: IFormlyAddonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.class = _data["class"];
        }
    }

    static fromJS(data: any): FormlyAddonDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormlyAddonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["class"] = this.class;
        return data;
    }
}

/** Can be used to add addons to the formly model https://ngx-formly.github.io/ngx-formly/examples/bootstrap-specific/input-add-ons */
export interface IFormlyAddonDto {
    /** A text addon */
    text?: string | undefined;
    /** An addon in the form of a class to display for example an Font Awesome icon */
    class?: string | undefined;
}

/** Gets the dependent references in proper formly forms format */
export class FormlyExpressionPropertiesDto implements IFormlyExpressionPropertiesDto {
    /** Holds the dependent parameter reference */
    templateOptions?: string | undefined;

    constructor(data?: IFormlyExpressionPropertiesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateOptions = _data["templateOptions"];
        }
    }

    static fromJS(data: any): FormlyExpressionPropertiesDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormlyExpressionPropertiesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateOptions"] = this.templateOptions;
        return data;
    }
}

/** Gets the dependent references in proper formly forms format */
export interface IFormlyExpressionPropertiesDto {
    /** Holds the dependent parameter reference */
    templateOptions?: string | undefined;
}

/** Formly Model for constructing dynamic UI */
export class FormlyModelDto implements IFormlyModelDto {
    /** Key of Element/Parameter */
    key?: string | undefined;
    /** Name of Element/Parameter */
    name?: string | undefined;
    /** The type of the Input field (so Input, TextArea, SelectList or Checkbox) */
    type?: string | undefined;
    /** Formly wrappers */
    wrappers?: string[] | undefined;
    templateOptions?: FormlyTemplateOptionsDto;
    expressionProperties?: FormlyExpressionPropertiesDto;
    /** Children of this WE.AMP.Models.DataTransferObjects.FormlyModel.FormlyModelDto */
    fieldGroup?: FormlyModelDto[] | undefined;

    constructor(data?: IFormlyModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.name = _data["name"];
            this.type = _data["type"];
            if (Array.isArray(_data["wrappers"])) {
                this.wrappers = [] as any;
                for (let item of _data["wrappers"])
                    this.wrappers!.push(item);
            }
            this.templateOptions = _data["templateOptions"] ? FormlyTemplateOptionsDto.fromJS(_data["templateOptions"]) : undefined as any;
            this.expressionProperties = _data["expressionProperties"] ? FormlyExpressionPropertiesDto.fromJS(_data["expressionProperties"]) : undefined as any;
            if (Array.isArray(_data["fieldGroup"])) {
                this.fieldGroup = [] as any;
                for (let item of _data["fieldGroup"])
                    this.fieldGroup!.push(FormlyModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormlyModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormlyModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["name"] = this.name;
        data["type"] = this.type;
        if (Array.isArray(this.wrappers)) {
            data["wrappers"] = [];
            for (let item of this.wrappers)
                data["wrappers"].push(item);
        }
        data["templateOptions"] = this.templateOptions ? this.templateOptions.toJSON() : undefined as any;
        data["expressionProperties"] = this.expressionProperties ? this.expressionProperties.toJSON() : undefined as any;
        if (Array.isArray(this.fieldGroup)) {
            data["fieldGroup"] = [];
            for (let item of this.fieldGroup)
                data["fieldGroup"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Formly Model for constructing dynamic UI */
export interface IFormlyModelDto {
    /** Key of Element/Parameter */
    key?: string | undefined;
    /** Name of Element/Parameter */
    name?: string | undefined;
    /** The type of the Input field (so Input, TextArea, SelectList or Checkbox) */
    type?: string | undefined;
    /** Formly wrappers */
    wrappers?: string[] | undefined;
    templateOptions?: FormlyTemplateOptionsDto;
    expressionProperties?: FormlyExpressionPropertiesDto;
    /** Children of this WE.AMP.Models.DataTransferObjects.FormlyModel.FormlyModelDto */
    fieldGroup?: FormlyModelDto[] | undefined;
}

/** Formly model for Parameter options */
export class FormlyParameterOptionsDto implements IFormlyParameterOptionsDto {
    /** Label of parameter option */
    label?: string | undefined;
    /** Value of parameter option */
    value?: string | undefined;

    constructor(data?: IFormlyParameterOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FormlyParameterOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormlyParameterOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

/** Formly model for Parameter options */
export interface IFormlyParameterOptionsDto {
    /** Label of parameter option */
    label?: string | undefined;
    /** Value of parameter option */
    value?: string | undefined;
}

/** Gets or sets the tree of Entities for building Dynamic UI */
export class FormlyProjectModelTreeDto implements IFormlyProjectModelTreeDto {
    /** Unique identifier of WE.AMP.Models.Entities.ContentVersion */
    contentVersionId?: number;
    /** Tree structure of Formly model */
    formlyModels?: FormlyModelDto[] | undefined;

    constructor(data?: IFormlyProjectModelTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentVersionId = _data["contentVersionId"];
            if (Array.isArray(_data["formlyModels"])) {
                this.formlyModels = [] as any;
                for (let item of _data["formlyModels"])
                    this.formlyModels!.push(FormlyModelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormlyProjectModelTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormlyProjectModelTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentVersionId"] = this.contentVersionId;
        if (Array.isArray(this.formlyModels)) {
            data["formlyModels"] = [];
            for (let item of this.formlyModels)
                data["formlyModels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Gets or sets the tree of Entities for building Dynamic UI */
export interface IFormlyProjectModelTreeDto {
    /** Unique identifier of WE.AMP.Models.Entities.ContentVersion */
    contentVersionId?: number;
    /** Tree structure of Formly model */
    formlyModels?: FormlyModelDto[] | undefined;
}

/** Formly model for WE.AMP.Models.Entities.FormlyModel.TemplateOptions */
export class FormlyTemplateOptionsDto implements IFormlyTemplateOptionsDto {
    /** name of the parameter */
    label?: string | undefined;
    /** defines whether input control is checked */
    checked?: boolean | undefined;
    /** defines whether input control is disabled */
    disabled?: boolean | undefined;
    /** defines whether input control is of type hidden */
    hidden?: boolean | undefined;
    /** defines the maximum size of input data */
    max?: number | undefined;
    /** defines the minimum size of input data */
    min?: number | undefined;
    /** define whether input control is readonly */
    readonly?: boolean | undefined;
    /** defines the number of numbers allowed after decimal */
    decimalPrecision?: number | undefined;
    /** defines the max length of input */
    maxlength?: number | undefined;
    /** define the pattern for parameter */
    pattern?: string | undefined;
    /** defines the input type */
    type?: string | undefined;
    addonRight?: FormlyAddonDto;
    addonLeft?: FormlyAddonDto;
    /** defines the parameter options */
    options?: FormlyParameterOptionsDto[] | undefined;

    constructor(data?: IFormlyTemplateOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.checked = _data["checked"];
            this.disabled = _data["disabled"];
            this.hidden = _data["hidden"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.readonly = _data["readonly"];
            this.decimalPrecision = _data["decimalPrecision"];
            this.maxlength = _data["maxlength"];
            this.pattern = _data["pattern"];
            this.type = _data["type"];
            this.addonRight = _data["addonRight"] ? FormlyAddonDto.fromJS(_data["addonRight"]) : undefined as any;
            this.addonLeft = _data["addonLeft"] ? FormlyAddonDto.fromJS(_data["addonLeft"]) : undefined as any;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(FormlyParameterOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormlyTemplateOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormlyTemplateOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["checked"] = this.checked;
        data["disabled"] = this.disabled;
        data["hidden"] = this.hidden;
        data["max"] = this.max;
        data["min"] = this.min;
        data["readonly"] = this.readonly;
        data["decimalPrecision"] = this.decimalPrecision;
        data["maxlength"] = this.maxlength;
        data["pattern"] = this.pattern;
        data["type"] = this.type;
        data["addonRight"] = this.addonRight ? this.addonRight.toJSON() : undefined as any;
        data["addonLeft"] = this.addonLeft ? this.addonLeft.toJSON() : undefined as any;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Formly model for WE.AMP.Models.Entities.FormlyModel.TemplateOptions */
export interface IFormlyTemplateOptionsDto {
    /** name of the parameter */
    label?: string | undefined;
    /** defines whether input control is checked */
    checked?: boolean | undefined;
    /** defines whether input control is disabled */
    disabled?: boolean | undefined;
    /** defines whether input control is of type hidden */
    hidden?: boolean | undefined;
    /** defines the maximum size of input data */
    max?: number | undefined;
    /** defines the minimum size of input data */
    min?: number | undefined;
    /** define whether input control is readonly */
    readonly?: boolean | undefined;
    /** defines the number of numbers allowed after decimal */
    decimalPrecision?: number | undefined;
    /** defines the max length of input */
    maxlength?: number | undefined;
    /** define the pattern for parameter */
    pattern?: string | undefined;
    /** defines the input type */
    type?: string | undefined;
    addonRight?: FormlyAddonDto;
    addonLeft?: FormlyAddonDto;
    /** defines the parameter options */
    options?: FormlyParameterOptionsDto[] | undefined;
}

/** Dto for UI select box for icons */
export class ImageIconSelectBoxDto implements IImageIconSelectBoxDto {
    /** Gets or sets the unique identifier of entity */
    id?: number;
    /** Gets or sets the name of entity */
    name?: string | undefined;
    /** Gets or sets the path of icon */
    iconPath?: string | undefined;
    /** Gets or sets the name of image with extension
<br>this name will be saved in db and the path of image will be reconstructed based on the type of element */
    nameWithExtension?: string | undefined;

    constructor(data?: IImageIconSelectBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.iconPath = _data["iconPath"];
            this.nameWithExtension = _data["nameWithExtension"];
        }
    }

    static fromJS(data: any): ImageIconSelectBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageIconSelectBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["iconPath"] = this.iconPath;
        data["nameWithExtension"] = this.nameWithExtension;
        return data;
    }
}

/** Dto for UI select box for icons */
export interface IImageIconSelectBoxDto {
    /** Gets or sets the unique identifier of entity */
    id?: number;
    /** Gets or sets the name of entity */
    name?: string | undefined;
    /** Gets or sets the path of icon */
    iconPath?: string | undefined;
    /** Gets or sets the name of image with extension
<br>this name will be saved in db and the path of image will be reconstructed based on the type of element */
    nameWithExtension?: string | undefined;
}

/** Defines the Input Sub Type for WE.AMP.Models.Entities.FormlyModel.TemplateOptions */
export class InputSubTypeDto implements IInputSubTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the value */
    value!: string;
    /** Collection of Template Options of particular Input Sub Type */
    templateOptionses?: TemplateOptionsDto[] | undefined;

    constructor(data?: IInputSubTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
            if (Array.isArray(_data["templateOptionses"])) {
                this.templateOptionses = [] as any;
                for (let item of _data["templateOptionses"])
                    this.templateOptionses!.push(TemplateOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InputSubTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputSubTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        if (Array.isArray(this.templateOptionses)) {
            data["templateOptionses"] = [];
            for (let item of this.templateOptionses)
                data["templateOptionses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Defines the Input Sub Type for WE.AMP.Models.Entities.FormlyModel.TemplateOptions */
export interface IInputSubTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the value */
    value: string;
    /** Collection of Template Options of particular Input Sub Type */
    templateOptionses?: TemplateOptionsDto[] | undefined;
}

/** <br>Gets or sets the input type for N:WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter <br>Used to store the types of input, for instance text, checkbox or radio */
export class InputTypeDto implements IInputTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Value of the input type */
    value?: string | undefined;

    constructor(data?: IInputTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InputTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new InputTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

/** <br>Gets or sets the input type for N:WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter <br>Used to store the types of input, for instance text, checkbox or radio */
export interface IInputTypeDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Value of the input type */
    value?: string | undefined;
}

/** <br>Gets or sets the tree of Entities (WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto, or WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto) for a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to Get or set the Project- or Assessment model tree */
export class ModelTreeDto implements IModelTreeDto {
    /** Gets or sets the unique Identifier of the WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId?: number;
    /** Gets or sets the List of WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForTreeDto to either be displayed in a tree on the UI or added, changed or deleted in a tree on the server */
    entitiesForTreeDto?: AssessmentOrProjectModelEntityForTreeDto[] | undefined;

    constructor(data?: IModelTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contentVersionId = _data["contentVersionId"];
            if (Array.isArray(_data["entitiesForTreeDto"])) {
                this.entitiesForTreeDto = [] as any;
                for (let item of _data["entitiesForTreeDto"])
                    this.entitiesForTreeDto!.push(AssessmentOrProjectModelEntityForTreeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ModelTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModelTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentVersionId"] = this.contentVersionId;
        if (Array.isArray(this.entitiesForTreeDto)) {
            data["entitiesForTreeDto"] = [];
            for (let item of this.entitiesForTreeDto)
                data["entitiesForTreeDto"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the tree of Entities (WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto, or WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto) for a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to Get or set the Project- or Assessment model tree */
export interface IModelTreeDto {
    /** Gets or sets the unique Identifier of the WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    contentVersionId?: number;
    /** Gets or sets the List of WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForTreeDto to either be displayed in a tree on the UI or added, changed or deleted in a tree on the server */
    entitiesForTreeDto?: AssessmentOrProjectModelEntityForTreeDto[] | undefined;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.OrganizationDto <br>Used to describe the organization as it is used the user management service */
export class OrganizationDto implements IOrganizationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets the unique Identifier of the organization in the user management service */
    gprGebruikersId!: number;
    /** Gets or sets WE.AMP.Models.DataTransferObjects.UserDto related to this organization */
    users?: UserDto[] | undefined;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.gprGebruikersId = _data["gprGebruikersId"];
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["gprGebruikersId"] = this.gprGebruikersId;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.OrganizationDto <br>Used to describe the organization as it is used the user management service */
export interface IOrganizationDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets the unique Identifier of the organization in the user management service */
    gprGebruikersId: number;
    /** Gets or sets WE.AMP.Models.DataTransferObjects.UserDto related to this organization */
    users?: UserDto[] | undefined;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto, update existing ones or get data from the database in this structure */
export class ParameterByCalculationCoreExpressionDto implements IParameterByCalculationCoreExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
    parameterId!: number;
    parameter?: ParameterDto;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto.CalculationCoreExpression */
    calculationCoreExpressionId!: number;
    calculationCoreExpression?: CalculationCoreExpressionDto;

    constructor(data?: IParameterByCalculationCoreExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.calculationCoreExpressionId = _data["calculationCoreExpressionId"];
            this.calculationCoreExpression = _data["calculationCoreExpression"] ? CalculationCoreExpressionDto.fromJS(_data["calculationCoreExpression"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParameterByCalculationCoreExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterByCalculationCoreExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["calculationCoreExpressionId"] = this.calculationCoreExpressionId;
        data["calculationCoreExpression"] = this.calculationCoreExpression ? this.calculationCoreExpression.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto <br>Can be used to create a new WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto, update existing ones or get data from the database in this structure */
export interface IParameterByCalculationCoreExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
    parameterId: number;
    parameter?: ParameterDto;
    /** Gets or sets Unique identifier of WE.AMP.Models.DataTransferObjects.CalculationModel.ParameterByCalculationCoreExpressionDto.CalculationCoreExpression */
    calculationCoreExpressionId: number;
    calculationCoreExpression?: CalculationCoreExpressionDto;
}

/** <br>Gets or sets the relation of a WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto to an WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto <br>Used to add a WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto to an WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto for the certain WE.AMP.Models.DataTransferObjects.ContentVersionDto and to set the order in which the WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto should appear in it */
export class ParameterByElementByContentVersionDto implements IParameterByElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the order for this entity to be used in a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    order?: number;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterByElementByContentVersionDto.Parameter */
    parameterId!: number;
    parameter?: ParameterDto;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterByElementByContentVersionDto.ElementByContentVersion */
    elementByContentVersionId!: number;
    elementByContentVersion?: ElementByContentVersionDto;

    constructor(data?: IParameterByElementByContentVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.order = _data["order"];
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.elementByContentVersionId = _data["elementByContentVersionId"];
            this.elementByContentVersion = _data["elementByContentVersion"] ? ElementByContentVersionDto.fromJS(_data["elementByContentVersion"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParameterByElementByContentVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterByElementByContentVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["order"] = this.order;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["elementByContentVersionId"] = this.elementByContentVersionId;
        data["elementByContentVersion"] = this.elementByContentVersion ? this.elementByContentVersion.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the relation of a WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto to an WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementByContentVersionDto <br>Used to add a WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto to an WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto for the certain WE.AMP.Models.DataTransferObjects.ContentVersionDto and to set the order in which the WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto should appear in it */
export interface IParameterByElementByContentVersionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the order for this entity to be used in a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    order?: number;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterByElementByContentVersionDto.Parameter */
    parameterId: number;
    parameter?: ParameterDto;
    /** Gets or sets the Unique identifier of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterByElementByContentVersionDto.ElementByContentVersion */
    elementByContentVersionId: number;
    elementByContentVersion?: ElementByContentVersionDto;
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto <br>Can be used to create a new property, update existing ones or get data from the database in this structure */
export class ParameterDto implements IParameterDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Parameter Type Id of an ParameterType */
    parameterTypeId?: number;
    /** Gets or sets the key for multi language. */
    key?: string | undefined;
    /** Gets or sets Data Member Id of an DataMember */
    dataMemberId?: number | undefined;
    dataMember?: DataMemberDto;
    /** Gets or sets a collection of WE.AMP.Models.Entities.ProjectModel.ParameterOverride */
    parameterOverrides?: ParameterOverrideDto[] | undefined;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.DependentDto */
    dependentOn?: DependentDto[] | undefined;

    constructor(data?: IParameterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.parameterTypeId = _data["parameterTypeId"];
            this.key = _data["key"];
            this.dataMemberId = _data["dataMemberId"];
            this.dataMember = _data["dataMember"] ? DataMemberDto.fromJS(_data["dataMember"]) : undefined as any;
            if (Array.isArray(_data["parameterOverrides"])) {
                this.parameterOverrides = [] as any;
                for (let item of _data["parameterOverrides"])
                    this.parameterOverrides!.push(ParameterOverrideDto.fromJS(item));
            }
            if (Array.isArray(_data["dependentOn"])) {
                this.dependentOn = [] as any;
                for (let item of _data["dependentOn"])
                    this.dependentOn!.push(DependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["parameterTypeId"] = this.parameterTypeId;
        data["key"] = this.key;
        data["dataMemberId"] = this.dataMemberId;
        data["dataMember"] = this.dataMember ? this.dataMember.toJSON() : undefined as any;
        if (Array.isArray(this.parameterOverrides)) {
            data["parameterOverrides"] = [];
            for (let item of this.parameterOverrides)
                data["parameterOverrides"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dependentOn)) {
            data["dependentOn"] = [];
            for (let item of this.dependentOn)
                data["dependentOn"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto <br>Can be used to create a new property, update existing ones or get data from the database in this structure */
export interface IParameterDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Parameter Type Id of an ParameterType */
    parameterTypeId?: number;
    /** Gets or sets the key for multi language. */
    key?: string | undefined;
    /** Gets or sets Data Member Id of an DataMember */
    dataMemberId?: number | undefined;
    dataMember?: DataMemberDto;
    /** Gets or sets a collection of WE.AMP.Models.Entities.ProjectModel.ParameterOverride */
    parameterOverrides?: ParameterOverrideDto[] | undefined;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.DependentDto */
    dependentOn?: DependentDto[] | undefined;
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto <br>Used to to store values for a dropdown or radio button UI element */
export class ParameterOptionDto implements IParameterOptionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the name of parameter */
    name?: string | undefined;
    /** Gets or sets the key for multi language. */
    key?: string | undefined;
    /** Gets or sets the order in which this entity should appear in a list */
    order?: number;
    /** Gets or sets  ParameterOverrideId */
    parameterOverrideId?: number;
    /** Gets or sets the EnumId from !:BuildingUseFunctionEnum.Id or EnergyTypeEnum.Id (From CalCore) */
    enumId?: number;
    parameterOverride?: ParameterOverrideDto;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.DependentDto */
    dependents?: DependentDto[] | undefined;

    constructor(data?: IParameterOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            this.order = _data["order"];
            this.parameterOverrideId = _data["parameterOverrideId"];
            this.enumId = _data["enumId"];
            this.parameterOverride = _data["parameterOverride"] ? ParameterOverrideDto.fromJS(_data["parameterOverride"]) : undefined as any;
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(DependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        data["order"] = this.order;
        data["parameterOverrideId"] = this.parameterOverrideId;
        data["enumId"] = this.enumId;
        data["parameterOverride"] = this.parameterOverride ? this.parameterOverride.toJSON() : undefined as any;
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the properties of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto <br>Used to to store values for a dropdown or radio button UI element */
export interface IParameterOptionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the name of parameter */
    name?: string | undefined;
    /** Gets or sets the key for multi language. */
    key?: string | undefined;
    /** Gets or sets the order in which this entity should appear in a list */
    order?: number;
    /** Gets or sets  ParameterOverrideId */
    parameterOverrideId?: number;
    /** Gets or sets the EnumId from !:BuildingUseFunctionEnum.Id or EnergyTypeEnum.Id (From CalCore) */
    enumId?: number;
    parameterOverride?: ParameterOverrideDto;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.DependentDto */
    dependents?: DependentDto[] | undefined;
}

/** Dto for WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOverrideDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
export class ParameterOverrideDto implements IParameterOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Parameter identifier of a Parameter */
    parameterId?: number;
    parameter?: ParameterDto;
    /** Gets or sets ContentVersion identifier of a Parameter */
    contentVersionId!: number;
    /** Gets or sets the name of element */
    name!: string;
    /** Gets or sets the description */
    description?: string | undefined;
    /** Gets or sets the label of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOverrideDto as we will use it in the UI, if null, use Name in the UI */
    label?: string | undefined;
    /** Gets or sets the dependency logic */
    dependencyLogic?: string | undefined;
    /** Gets or sets the icon path */
    iconPath?: string | undefined;
    /** Gets or sets unique identifier of a Unit */
    unitId?: number | undefined;
    unit?: UnitDto;
    /** Gets or sets unique identifier of an InputType */
    inputTypeId!: number;
    inputType?: InputTypeDto;
    /** Gets or Sets unique identifier for TemplateOptions */
    templateOptionId?: number;
    templateOptions?: TemplateOptionsDto;
    /** Gets or sets the list of ParameterOptions for Parameter */
    parameterOptions?: ParameterOptionDto[] | undefined;
    /** Gets or sets the list of parameter WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.DependentDto */
    dependents?: DependentDto[] | undefined;

    constructor(data?: IParameterOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.parameterId = _data["parameterId"];
            this.parameter = _data["parameter"] ? ParameterDto.fromJS(_data["parameter"]) : undefined as any;
            this.contentVersionId = _data["contentVersionId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.label = _data["label"];
            this.dependencyLogic = _data["dependencyLogic"];
            this.iconPath = _data["iconPath"];
            this.unitId = _data["unitId"];
            this.unit = _data["unit"] ? UnitDto.fromJS(_data["unit"]) : undefined as any;
            this.inputTypeId = _data["inputTypeId"];
            this.inputType = _data["inputType"] ? InputTypeDto.fromJS(_data["inputType"]) : undefined as any;
            this.templateOptionId = _data["templateOptionId"];
            this.templateOptions = _data["templateOptions"] ? TemplateOptionsDto.fromJS(_data["templateOptions"]) : undefined as any;
            if (Array.isArray(_data["parameterOptions"])) {
                this.parameterOptions = [] as any;
                for (let item of _data["parameterOptions"])
                    this.parameterOptions!.push(ParameterOptionDto.fromJS(item));
            }
            if (Array.isArray(_data["dependents"])) {
                this.dependents = [] as any;
                for (let item of _data["dependents"])
                    this.dependents!.push(DependentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["parameterId"] = this.parameterId;
        data["parameter"] = this.parameter ? this.parameter.toJSON() : undefined as any;
        data["contentVersionId"] = this.contentVersionId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["label"] = this.label;
        data["dependencyLogic"] = this.dependencyLogic;
        data["iconPath"] = this.iconPath;
        data["unitId"] = this.unitId;
        data["unit"] = this.unit ? this.unit.toJSON() : undefined as any;
        data["inputTypeId"] = this.inputTypeId;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined as any;
        data["templateOptionId"] = this.templateOptionId;
        data["templateOptions"] = this.templateOptions ? this.templateOptions.toJSON() : undefined as any;
        if (Array.isArray(this.parameterOptions)) {
            data["parameterOptions"] = [];
            for (let item of this.parameterOptions)
                data["parameterOptions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dependents)) {
            data["dependents"] = [];
            for (let item of this.dependents)
                data["dependents"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Dto for WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOverrideDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
export interface IParameterOverrideDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Parameter identifier of a Parameter */
    parameterId?: number;
    parameter?: ParameterDto;
    /** Gets or sets ContentVersion identifier of a Parameter */
    contentVersionId: number;
    /** Gets or sets the name of element */
    name: string;
    /** Gets or sets the description */
    description?: string | undefined;
    /** Gets or sets the label of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterOverrideDto as we will use it in the UI, if null, use Name in the UI */
    label?: string | undefined;
    /** Gets or sets the dependency logic */
    dependencyLogic?: string | undefined;
    /** Gets or sets the icon path */
    iconPath?: string | undefined;
    /** Gets or sets unique identifier of a Unit */
    unitId?: number | undefined;
    unit?: UnitDto;
    /** Gets or sets unique identifier of an InputType */
    inputTypeId: number;
    inputType?: InputTypeDto;
    /** Gets or Sets unique identifier for TemplateOptions */
    templateOptionId?: number;
    templateOptions?: TemplateOptionsDto;
    /** Gets or sets the list of ParameterOptions for Parameter */
    parameterOptions?: ParameterOptionDto[] | undefined;
    /** Gets or sets the list of parameter WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.DependentDto */
    dependents?: DependentDto[] | undefined;
}

/** <br>Gets or sets the relationship between WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto and WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto <br>Used to get the list of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto that are linked to a WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto to see which ones are affected when the WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto is evaluated */
export class ParameterToAssessmentExpressionByAssessmentEntityDto implements IParameterToAssessmentExpressionByAssessmentEntityDto {
    /** Gets and  Unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionId!: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    /** Gets or sets the  Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionByAssessmentEntityDto.ParameterToAssessmentExpression */
    parameterToAssessmentExpressionId!: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;

    constructor(data?: IParameterToAssessmentExpressionByAssessmentEntityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assessmentEntityByContentVersionId = _data["assessmentEntityByContentVersionId"];
            this.assessmentEntityByContentVersion = _data["assessmentEntityByContentVersion"] ? AssessmentEntityByContentVersionDto.fromJS(_data["assessmentEntityByContentVersion"]) : undefined as any;
            this.parameterToAssessmentExpressionId = _data["parameterToAssessmentExpressionId"];
            this.parameterToAssessmentExpression = _data["parameterToAssessmentExpression"] ? ParameterToAssessmentExpressionDto.fromJS(_data["parameterToAssessmentExpression"]) : undefined as any;
        }
    }

    static fromJS(data: any): ParameterToAssessmentExpressionByAssessmentEntityDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterToAssessmentExpressionByAssessmentEntityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assessmentEntityByContentVersionId"] = this.assessmentEntityByContentVersionId;
        data["assessmentEntityByContentVersion"] = this.assessmentEntityByContentVersion ? this.assessmentEntityByContentVersion.toJSON() : undefined as any;
        data["parameterToAssessmentExpressionId"] = this.parameterToAssessmentExpressionId;
        data["parameterToAssessmentExpression"] = this.parameterToAssessmentExpression ? this.parameterToAssessmentExpression.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets the relationship between WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto and WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto <br>Used to get the list of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto that are linked to a WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto to see which ones are affected when the WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto is evaluated */
export interface IParameterToAssessmentExpressionByAssessmentEntityDto {
    /** Gets and  Unique identifier of WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityByContentVersionDto */
    assessmentEntityByContentVersionId: number;
    assessmentEntityByContentVersion?: AssessmentEntityByContentVersionDto;
    /** Gets or sets the  Unique identifier of WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionByAssessmentEntityDto.ParameterToAssessmentExpression */
    parameterToAssessmentExpressionId: number;
    parameterToAssessmentExpression?: ParameterToAssessmentExpressionDto;
}

/** <br>Gets or sets the data of an expression WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto <br>Can be used to connect the Project model to the Assessment model and be evaluated when a user enters data */
export class ParameterToAssessmentExpressionDto implements IParameterToAssessmentExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Name of the expression */
    name?: string | undefined;
    /** Gets or sets the Explanation about expression */
    explanation?: string | undefined;
    /** Gets or sets the Actual value of expression like: "({1}>=6) AND ({2}=True)". The values between curly brackets are the unique identifiers of the WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDtos of which the user entered data is used to evaluate the expression */
    value!: string;
    /** True if expression is mapped with parameter
<br> If True, then expression cannot be edited  */
    readonly isMappedWithParameter?: boolean;
    /** Flag determine whether user is using the existing expression from WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto or creating new expression
<br>True if creating new expression WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto<br>False if using existing expression WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto */
    isNew?: boolean;
    /** Gets or sets a collection of Many to many relationships between this WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto on the one hand and WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto on the other, for a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;
    /** Gets or sets Many to many relationship between this WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto and WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
    parameterToAssessmentExpressionByAssessmentEntities?: ParameterToAssessmentExpressionByAssessmentEntityDto[] | undefined;

    constructor(data?: IParameterToAssessmentExpressionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.name = _data["name"];
            this.explanation = _data["explanation"];
            this.value = _data["value"];
            (this as any).isMappedWithParameter = _data["isMappedWithParameter"];
            this.isNew = _data["isNew"];
            if (Array.isArray(_data["expressionByParameterElementAndContentVersions"])) {
                this.expressionByParameterElementAndContentVersions = [] as any;
                for (let item of _data["expressionByParameterElementAndContentVersions"])
                    this.expressionByParameterElementAndContentVersions!.push(ExpressionByParameterElementAndContentVersionDto.fromJS(item));
            }
            if (Array.isArray(_data["parameterToAssessmentExpressionByAssessmentEntities"])) {
                this.parameterToAssessmentExpressionByAssessmentEntities = [] as any;
                for (let item of _data["parameterToAssessmentExpressionByAssessmentEntities"])
                    this.parameterToAssessmentExpressionByAssessmentEntities!.push(ParameterToAssessmentExpressionByAssessmentEntityDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ParameterToAssessmentExpressionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterToAssessmentExpressionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["name"] = this.name;
        data["explanation"] = this.explanation;
        data["value"] = this.value;
        data["isMappedWithParameter"] = this.isMappedWithParameter;
        data["isNew"] = this.isNew;
        if (Array.isArray(this.expressionByParameterElementAndContentVersions)) {
            data["expressionByParameterElementAndContentVersions"] = [];
            for (let item of this.expressionByParameterElementAndContentVersions)
                data["expressionByParameterElementAndContentVersions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.parameterToAssessmentExpressionByAssessmentEntities)) {
            data["parameterToAssessmentExpressionByAssessmentEntities"] = [];
            for (let item of this.parameterToAssessmentExpressionByAssessmentEntities)
                data["parameterToAssessmentExpressionByAssessmentEntities"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** <br>Gets or sets the data of an expression WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto <br>Can be used to connect the Project model to the Assessment model and be evaluated when a user enters data */
export interface IParameterToAssessmentExpressionDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets Name of the expression */
    name?: string | undefined;
    /** Gets or sets the Explanation about expression */
    explanation?: string | undefined;
    /** Gets or sets the Actual value of expression like: "({1}>=6) AND ({2}=True)". The values between curly brackets are the unique identifiers of the WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDtos of which the user entered data is used to evaluate the expression */
    value: string;
    /** True if expression is mapped with parameter
<br> If True, then expression cannot be edited  */
    isMappedWithParameter?: boolean;
    /** Flag determine whether user is using the existing expression from WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto or creating new expression
<br>True if creating new expression WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto<br>False if using existing expression WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto */
    isNew?: boolean;
    /** Gets or sets a collection of Many to many relationships between this WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto on the one hand and WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto on the other, for a certain WE.AMP.Models.DataTransferObjects.ContentVersionDto */
    expressionByParameterElementAndContentVersions?: ExpressionByParameterElementAndContentVersionDto[] | undefined;
    /** Gets or sets Many to many relationship between this WE.AMP.Models.DataTransferObjects.ExpressionModel.ParameterToAssessmentExpressionDto and WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto */
    parameterToAssessmentExpressionByAssessmentEntities?: ParameterToAssessmentExpressionByAssessmentEntityDto[] | undefined;
}

/** Define the pattern for  WE.AMP.Models.Entities.FormlyModel.TemplateOptions */
export class PatternDto implements IPatternDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets the value */
    value!: string;
    /** Collection of Template options of particular pattern */
    templateOptionses?: TemplateOptionsDto[] | undefined;

    constructor(data?: IPatternDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
            if (Array.isArray(_data["templateOptionses"])) {
                this.templateOptionses = [] as any;
                for (let item of _data["templateOptionses"])
                    this.templateOptionses!.push(TemplateOptionsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PatternDto {
        data = typeof data === 'object' ? data : {};
        let result = new PatternDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        if (Array.isArray(this.templateOptionses)) {
            data["templateOptionses"] = [];
            for (let item of this.templateOptionses)
                data["templateOptionses"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Define the pattern for  WE.AMP.Models.Entities.FormlyModel.TemplateOptions */
export interface IPatternDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets the value */
    value: string;
    /** Collection of Template options of particular pattern */
    templateOptionses?: TemplateOptionsDto[] | undefined;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

/** Dto for WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
export class ProjectModelDto implements IProjectModelDto {
    newElement?: ElementDto;
    /** Gets or sets the flag to add new element */
    addToTree?: boolean;
    /** Gets or sets the content Version Id */
    contentVersionId?: number;
    /** Gets or sets the Parent Id */
    parentElementByContentVersionId?: number | undefined;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto unique identifier
<br>collection of children (single elements in case NewElement is Composite) */
    childrenIds?: number[] | undefined;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto unique identifier */
    parameterIds?: number[] | undefined;

    constructor(data?: IProjectModelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.newElement = _data["newElement"] ? ElementDto.fromJS(_data["newElement"]) : undefined as any;
            this.addToTree = _data["addToTree"];
            this.contentVersionId = _data["contentVersionId"];
            this.parentElementByContentVersionId = _data["parentElementByContentVersionId"];
            if (Array.isArray(_data["childrenIds"])) {
                this.childrenIds = [] as any;
                for (let item of _data["childrenIds"])
                    this.childrenIds!.push(item);
            }
            if (Array.isArray(_data["parameterIds"])) {
                this.parameterIds = [] as any;
                for (let item of _data["parameterIds"])
                    this.parameterIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectModelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["newElement"] = this.newElement ? this.newElement.toJSON() : undefined as any;
        data["addToTree"] = this.addToTree;
        data["contentVersionId"] = this.contentVersionId;
        data["parentElementByContentVersionId"] = this.parentElementByContentVersionId;
        if (Array.isArray(this.childrenIds)) {
            data["childrenIds"] = [];
            for (let item of this.childrenIds)
                data["childrenIds"].push(item);
        }
        if (Array.isArray(this.parameterIds)) {
            data["parameterIds"] = [];
            for (let item of this.parameterIds)
                data["parameterIds"].push(item);
        }
        return data;
    }
}

/** Dto for WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto */
export interface IProjectModelDto {
    newElement?: ElementDto;
    /** Gets or sets the flag to add new element */
    addToTree?: boolean;
    /** Gets or sets the content Version Id */
    contentVersionId?: number;
    /** Gets or sets the Parent Id */
    parentElementByContentVersionId?: number | undefined;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Element.ElementDto unique identifier
<br>collection of children (single elements in case NewElement is Composite) */
    childrenIds?: number[] | undefined;
    /** Gets or sets the list of WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto unique identifier */
    parameterIds?: number[] | undefined;
}

/** Dto for UI select box */
export class SelectBoxDto implements ISelectBoxDto {
    /** Gets or sets the unique identifier of entity */
    id?: number;
    /** Gets or sets the name of entity */
    name?: string | undefined;

    constructor(data?: ISelectBoxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SelectBoxDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectBoxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** Dto for UI select box */
export interface ISelectBoxDto {
    /** Gets or sets the unique identifier of entity */
    id?: number;
    /** Gets or sets the name of entity */
    name?: string | undefined;
}

export class SmartEnumDto implements ISmartEnumDto {
    id?: number;
    name?: string | undefined;
    shortName?: string | undefined;

    constructor(data?: ISmartEnumDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
        }
    }

    static fromJS(data: any): SmartEnumDto {
        data = typeof data === 'object' ? data : {};
        let result = new SmartEnumDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        return data;
    }
}

export interface ISmartEnumDto {
    id?: number;
    name?: string | undefined;
    shortName?: string | undefined;
}

/** <br>Gets or sets the value of WE.AMP.Models.DataTransferObjects.StatusDto of a WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to store or update the status of a WE.AMP.Models.DataTransferObjects.ContentVersionDto for a new or exisisting entry in the database */
export class StatusDto implements IStatusDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets The Value of Status */
    value!: string;

    constructor(data?: IStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["value"] = this.value;
        return data;
    }
}

/** <br>Gets or sets the value of WE.AMP.Models.DataTransferObjects.StatusDto of a WE.AMP.Models.DataTransferObjects.ContentVersionDto <br>Used to store or update the status of a WE.AMP.Models.DataTransferObjects.ContentVersionDto for a new or exisisting entry in the database */
export interface IStatusDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets The Value of Status */
    value: string;
}

/** Class define various template options that are used to build formly */
export class TemplateOptionsDto implements ITemplateOptionsDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Default value of the input field */
    defaultValue?: string | undefined;
    /** defines whether input control is checked */
    checked?: boolean | undefined;
    /** defines whether input control is disabled */
    disabled?: boolean | undefined;
    /** defines whether input control is of type hidden */
    hidden?: boolean | undefined;
    /** defines the maximum size of input data */
    max?: number | undefined;
    /** defines the minimum size of input data */
    min?: number | undefined;
    /** Gets or sets whether the entered value should be greater than WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.Min,
if true Value > Min
if false Value >= Min */
    valueIsGreaterThanMin?: boolean;
    /** Gets or sets whether the entered value should be less than WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.Max,
if true Min > Value
if false Min >= Value */
    valueIsLessThanMax?: boolean;
    /** define whether input control is readonly */
    readonly?: boolean | undefined;
    /** defines the number of numbers allowed after decimal */
    decimalPrecision?: number | undefined;
    /** defines the max length of input */
    maxlength?: number | undefined;
    /** Unique id of WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.Pattern */
    patternId?: number | undefined;
    pattern?: PatternDto;
    /** Unique id of WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.InputSubType */
    inputSubTypeId?: number | undefined;
    inputSubType?: InputSubTypeDto;
    parameterOverride?: ParameterOverrideDto;

    constructor(data?: ITemplateOptionsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.defaultValue = _data["defaultValue"];
            this.checked = _data["checked"];
            this.disabled = _data["disabled"];
            this.hidden = _data["hidden"];
            this.max = _data["max"];
            this.min = _data["min"];
            this.valueIsGreaterThanMin = _data["valueIsGreaterThanMin"];
            this.valueIsLessThanMax = _data["valueIsLessThanMax"];
            this.readonly = _data["readonly"];
            this.decimalPrecision = _data["decimalPrecision"];
            this.maxlength = _data["maxlength"];
            this.patternId = _data["patternId"];
            this.pattern = _data["pattern"] ? PatternDto.fromJS(_data["pattern"]) : undefined as any;
            this.inputSubTypeId = _data["inputSubTypeId"];
            this.inputSubType = _data["inputSubType"] ? InputSubTypeDto.fromJS(_data["inputSubType"]) : undefined as any;
            this.parameterOverride = _data["parameterOverride"] ? ParameterOverrideDto.fromJS(_data["parameterOverride"]) : undefined as any;
        }
    }

    static fromJS(data: any): TemplateOptionsDto {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateOptionsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["defaultValue"] = this.defaultValue;
        data["checked"] = this.checked;
        data["disabled"] = this.disabled;
        data["hidden"] = this.hidden;
        data["max"] = this.max;
        data["min"] = this.min;
        data["valueIsGreaterThanMin"] = this.valueIsGreaterThanMin;
        data["valueIsLessThanMax"] = this.valueIsLessThanMax;
        data["readonly"] = this.readonly;
        data["decimalPrecision"] = this.decimalPrecision;
        data["maxlength"] = this.maxlength;
        data["patternId"] = this.patternId;
        data["pattern"] = this.pattern ? this.pattern.toJSON() : undefined as any;
        data["inputSubTypeId"] = this.inputSubTypeId;
        data["inputSubType"] = this.inputSubType ? this.inputSubType.toJSON() : undefined as any;
        data["parameterOverride"] = this.parameterOverride ? this.parameterOverride.toJSON() : undefined as any;
        return data;
    }
}

/** Class define various template options that are used to build formly */
export interface ITemplateOptionsDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Default value of the input field */
    defaultValue?: string | undefined;
    /** defines whether input control is checked */
    checked?: boolean | undefined;
    /** defines whether input control is disabled */
    disabled?: boolean | undefined;
    /** defines whether input control is of type hidden */
    hidden?: boolean | undefined;
    /** defines the maximum size of input data */
    max?: number | undefined;
    /** defines the minimum size of input data */
    min?: number | undefined;
    /** Gets or sets whether the entered value should be greater than WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.Min,
if true Value > Min
if false Value >= Min */
    valueIsGreaterThanMin?: boolean;
    /** Gets or sets whether the entered value should be less than WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.Max,
if true Min > Value
if false Min >= Value */
    valueIsLessThanMax?: boolean;
    /** define whether input control is readonly */
    readonly?: boolean | undefined;
    /** defines the number of numbers allowed after decimal */
    decimalPrecision?: number | undefined;
    /** defines the max length of input */
    maxlength?: number | undefined;
    /** Unique id of WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.Pattern */
    patternId?: number | undefined;
    pattern?: PatternDto;
    /** Unique id of WE.AMP.Models.DataTransferObjects.FormlyModel.TemplateOptionsDto.InputSubType */
    inputSubTypeId?: number | undefined;
    inputSubType?: InputSubTypeDto;
    parameterOverride?: ParameterOverrideDto;
}

/** <br>Gets or sets the value for WE.AMP.Models.DataTransferObjects.UnitDto <br>Used in the WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForFlatListDto, WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto, ex: m^2 */
export class UnitDto implements IUnitDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets Value of the unit, ex: m^2 */
    value?: string | undefined;

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): UnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

/** <br>Gets or sets the value for WE.AMP.Models.DataTransferObjects.UnitDto <br>Used in the WE.AMP.Models.DataTransferObjects.AssessmentOrProjectModelEntityForFlatListDto, WE.AMP.Models.DataTransferObjects.AssessmentModel.AssessmentEntityDto and WE.AMP.Models.DataTransferObjects.ProjectModel.Parameter.ParameterDto, ex: m^2 */
export interface IUnitDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets Value of the unit, ex: m^2 */
    value?: string | undefined;
}

/** <br>Gets or sets properties of a user <br>Used for storing the data for users from our user management service */
export class UserDto implements IUserDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets the unique identifier the user from our user management service */
    gprGebruikersId!: number;
    /** Gets or sets the OrganizationId as for */
    organizationId!: number;
    organization?: OrganizationDto;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : undefined as any;
            this.dateModified = _data["dateModified"] ? new Date(_data["dateModified"].toString()) : undefined as any;
            this.id = _data["id"];
            this.key = _data["key"];
            this.gprGebruikersId = _data["gprGebruikersId"];
            this.organizationId = _data["organizationId"];
            this.organization = _data["organization"] ? OrganizationDto.fromJS(_data["organization"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : undefined as any;
        data["dateModified"] = this.dateModified ? this.dateModified.toISOString() : undefined as any;
        data["id"] = this.id;
        data["key"] = this.key;
        data["gprGebruikersId"] = this.gprGebruikersId;
        data["organizationId"] = this.organizationId;
        data["organization"] = this.organization ? this.organization.toJSON() : undefined as any;
        return data;
    }
}

/** <br>Gets or sets properties of a user <br>Used for storing the data for users from our user management service */
export interface IUserDto {
    dateCreated?: Date;
    dateModified?: Date;
    id?: number;
    /** Gets or sets the key */
    key?: string | undefined;
    /** Gets or sets the unique identifier the user from our user management service */
    gprGebruikersId: number;
    /** Gets or sets the OrganizationId as for */
    organizationId: number;
    organization?: OrganizationDto;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}